import React, { useEffect, useState, useRef, useMemo } from "react";
import ReactDOM from "react-dom";
import ChatAICliente from "./ai/ChatAICliente";
import { useParams } from "react-router-dom";
import { db, auth } from "./firebase";
import { signInWithPhoneNumber, RecaptchaVerifier } from "firebase/auth";
import {
  getMessaging,
  getToken,
  isSupported
} from "firebase/messaging";
import OtpBottomSheet from "./OtpBottomSheet";

import {
  collection,
  doc,
  getDoc,
  getDocs,
  addDoc,
  deleteDoc,
  onSnapshot,
  serverTimestamp,
  query,
  where,
  setDoc,
  updateDoc,
  runTransaction
} from "firebase/firestore";

import "./MenuView.css";
import "./MenuAsportoOpt.css";
import AICliente from "./ai/AICliente";
import { defaultUIStrings } from "./uiStrings";

const ENABLE_OTP = true;

const getCatId = (name) =>
  String(name).toLowerCase().replace(/\s+/g, "-");

const resolveDishText = (dish, lingua) => {
  const getItalianName = () => {
    if (typeof dish.nome === "string") return dish.nome;
    if (dish.nome?.it) return dish.nome.it;
    return "";
  };

  const getItalianDescription = () => {
    if (typeof dish.descrizione === "string") return dish.descrizione;
    if (dish.descrizione?.it) return dish.descrizione.it;
    return "";
  };

  const getItalianIngredients = () => {
    if (Array.isArray(dish.ingredienti)) return dish.ingredienti;
    if (typeof dish.ingredienti === "string")
      return dish.ingredienti.split(",").map(i => i.trim()).filter(Boolean);
    return [];
  };

  const getItalianAllergens = () => {
    if (Array.isArray(dish.allergeni)) return dish.allergeni;
    if (typeof dish.allergeni === "string")
      return dish.allergeni.split(",").map(a => a.trim()).filter(Boolean);
    return [];
  };

  if (lingua === "it") {
    return {
      name: getItalianName(),
      description: getItalianDescription(),
      ingredients: getItalianIngredients(),
      allergens: getItalianAllergens()
    };
  }

  const name =
    dish.translations?.[lingua]?.name ||
    dish.translations?.[lingua]?.nome ||
    getItalianName();

  const description =
    dish.translations?.[lingua]?.description ||
    dish.translations?.[lingua]?.descrizione ||
    getItalianDescription();

  const ingredients =
    Array.isArray(dish.translations?.[lingua]?.ingredients) &&
    dish.translations[lingua].ingredients.length > 0
      ? dish.translations[lingua].ingredients
      : getItalianIngredients();

  const allergens =
    Array.isArray(dish.translations?.[lingua]?.allergens) &&
    dish.translations[lingua].allergens.length > 0
      ? dish.translations[lingua].allergens
      : getItalianAllergens();

  return { name, description, ingredients, allergens };
};

const resolveAllergensForView = (dish, lingua) => {
  const { allergens } = resolveDishText(dish, lingua);

  if (
    lingua !== "it" &&
    Array.isArray(dish.translations?.[lingua]?.allergens) &&
    dish.translations[lingua].allergens.length > 0
  ) {
    return allergens;
  }

  return Array.isArray(allergens)
    ? allergens.map(a => translateAllergen(a, lingua))
    : [];
};


const ALLERGENI_I18N = {
  it: {
    "Latte": "Latte",
    "Uova": "Uova",
    "Pesce": "Pesce",
    "Crostacei": "Crostacei",
    "Cereali contenenti glutine": "Gluten",
    "Soia": "Soia",
    "Frutta a guscio": "Frutta a guscio",
    "Sedano": "Sedano",
    "Senape": "Senape",
    "Sesamo": "Sesamo",
    "Solfiti": "Solfiti",
    "Lupini": "Lupini",
    "Molluschi": "Molluschi"
  },
  en: {
    "Latte": "Milk",
    "Uova": "Eggs",
    "Pesce": "Fish",
    "Crostacei": "Crustaceans",
    "Cereali contenenti glutine": "Gluten",
    "Soia": "Soy",
    "Frutta a guscio": "Nuts",
    "Sedano": "Celery",
    "Senape": "Mustard",
    "Sesamo": "Sesame",
    "Solfiti": "Sulphites",
    "Lupini": "Lupin",
    "Molluschi": "Molluscs"
  }
};

const translateAllergen = (label, lang) =>
  ALLERGENI_I18N[lang]?.[label] || label;


// ...existing code...
const SuggestionPopup = React.memo(({
  suggestionPopup,
  selectedSuggestions,
  setSuggestionPopup,
  setSelectedSuggestions,
  fetchAISuggestions,
  addDishToCart,
   TT
}) => {

  if (!suggestionPopup.open || !suggestionPopup.dish)
    return null;

  const dishName = typeof suggestionPopup.dish.nome === "string"
    ? suggestionPopup.dish.nome
    : suggestionPopup.dish.nome?.it || "";

  // Stato 1: Chiedi se vuoi suggerimenti
  if ((!suggestionPopup.suggestions || suggestionPopup.suggestions.length === 0) && !suggestionPopup.loading && !suggestionPopup.asked) {
    return (
      <div
        className="suggestion-popup-overlay"
        onClick={() => {
          setSuggestionPopup({ open: false, dish: null, suggestions: [], loading: false, quantity: 1, custom: "", asked: false });
          setSelectedSuggestions(new Set());
        }}
      >
        <div className="suggestion-popup-content" onClick={(e) => e.stopPropagation()}>
          <button
            className="suggestion-popup-close"
            onClick={() => {
              setSuggestionPopup({ open: false, dish: null, suggestions: [], loading: false, quantity: 1, custom: "", asked: false });
              setSelectedSuggestions(new Set());
            }}
          >✕</button>
          <h3>{TT.suggestionPopupTitle || "Ti consiglio qualcosa?"}</h3>
          <p>{TT.suggestionPopupText || "Vuoi che ti suggerisca degli abbinamenti per"} <strong>{dishName}</strong>?</p>
          <div style={{ display: "flex", flexDirection: "column", gap: "1rem", marginTop: "1rem" }}>
            <button
              className="suggestion-btn-yes"
              onClick={() => {
                setSuggestionPopup((prev) => ({ ...prev, asked: true }));
                fetchAISuggestions(suggestionPopup.dish);
              }}
            >{TT.suggestionYes || "Sì, suggeriscimi"}</button>
            <button
              className="suggestion-btn-no"
              onClick={async () => {
                await addDishToCart(suggestionPopup.dish, 1, suggestionPopup.custom);
                setSuggestionPopup({ open: false, dish: null, suggestions: [], loading: false, quantity: 1, custom: "", asked: false });
                setSelectedSuggestions(new Set());
              }}
            >{TT.suggestionNo || "No, solo questo"}</button>
          </div>
        </div>
      </div>
    );
  }

  // Stato 2: Caricamento
  if (suggestionPopup.loading) {
    return (
      <div
        className="suggestion-popup-overlay"
        onClick={() => {
          setSuggestionPopup({ open: false, dish: null, suggestions: [], loading: false, quantity: 1, custom: "", asked: false });
          setSelectedSuggestions(new Set());
        }}
      >
        <div className="suggestion-popup-content" onClick={(e) => e.stopPropagation()}>
          <button
            className="suggestion-popup-close"
            onClick={() => {
              setSuggestionPopup({ open: false, dish: null, suggestions: [], loading: false, quantity: 1, custom: "", asked: false });
              setSelectedSuggestions(new Set());
            }}
          >✕</button>
          <h3>{TT.suggestionPopupTitle || "Ti consiglio qualcosa?"}</h3>
          <p style={{ marginTop: "1rem", fontStyle: "italic", textAlign: "center" }}>
            ⏳ {TT.suggestionLoading || "Sto cercando gli abbinamenti migliori..."}
          </p>
        </div>
      </div>
    );
  }

  // Stato 3: Mostra suggerimenti
  if (suggestionPopup.suggestions.length > 0) {
    return (
      <div
        className="suggestion-popup-overlay"
        onClick={() => {
          setSuggestionPopup({ open: false, dish: null, suggestions: [], loading: false, quantity: 1, custom: "", asked: false });
          setSelectedSuggestions(new Set());
        }}
      >
        <div className="suggestion-popup-content" onClick={(e) => e.stopPropagation()}>
          <button
            className="suggestion-popup-close"
            onClick={() => {
              setSuggestionPopup({ open: false, dish: null, suggestions: [], loading: false, quantity: 1, custom: "", asked: false });
              setSelectedSuggestions(new Set());
            }}
          >✕</button>
          <h3>Abbinamenti suggeriti per <strong>{dishName}</strong></h3>
          <div style={{ marginTop: "1rem", maxHeight: "300px", overflowY: "auto" }}>
            {suggestionPopup.suggestions.map((sugg) => {
              const suggName = typeof sugg.nome === "string" ? sugg.nome : sugg.nome?.it || "";
              const isSelected = selectedSuggestions.has(sugg.id);
              return (
                <div
                  key={sugg.id}
                  onClick={() => {
                    const newSelected = new Set(selectedSuggestions);
                    if (isSelected) newSelected.delete(sugg.id);
                    else newSelected.add(sugg.id);
                    setSelectedSuggestions(newSelected);
                  }}
                  style={{
                    padding: "0.8rem",
                    marginBottom: "0.6rem",
                    border: isSelected ? "2px solid #246bff" : "1px solid rgba(255,255,255,0.12)",
                    borderRadius: "8px",
                    backgroundColor: isSelected ? "rgba(255,140,0,0.18)" : "rgba(255,255,255,0.04)",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.8rem",
                    transition: "all 0.2s ease"
                  }}
                >
                  <input type="checkbox" checked={isSelected} onChange={() => {}} style={{ cursor: "pointer", width: "18px", height: "18px" }} />
                  <div style={{ flex: 1 }}>
                    <strong style={{ color: "#fff" }}>{suggName}</strong>
                    {sugg.price && <span style={{ color: "rgba(255,255,255,0.6)", marginLeft: "0.5rem" }}>€{sugg.price.toFixed(2)}</span>}
                  </div>
                </div>
              );
            })}
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "1rem", marginTop: "1.5rem" }}>
            <button
              className="suggestion-btn-yes"
              onClick={async () => {
                await addDishToCart(suggestionPopup.dish, 1, suggestionPopup.custom);
                for (const suggestion of suggestionPopup.suggestions) {
                  if (selectedSuggestions.has(suggestion.id)) {
                    await addDishToCart(suggestion, 1, "");
                  }
                }
                setSuggestionPopup({ open: false, dish: null, suggestions: [], loading: false, quantity: 1, custom: "", asked: false });
                setSelectedSuggestions(new Set());
              }}
            >{TT.addSelectionCta || "✅ Aggiungi selezione"}</button>
            <button
              className="suggestion-btn-no"
              onClick={async () => {
                await addDishToCart(suggestionPopup.dish, 1, suggestionPopup.custom);
                setSuggestionPopup({ open: false, dish: null, suggestions: [], loading: false, quantity: 1, custom: "", asked: false });
                setSelectedSuggestions(new Set());
              }}
            >{TT.onlyDishCta || "➕ Solo il piatto"}</button>
          </div>
        </div>
      </div>
    );
  }

  return null;
});

// ===========================
// COMPONENTE PRINCIPALE
// ===========================

function MenuAsportoOpt() {
  const { localeTag } = useParams();

  const normalizedLocaleTag = localeTag
    .toLowerCase()
    .replace(/[^a-z0-9]/gi, "");

  const clientSessionId = useRef(
    localStorage.getItem("asportoSessionId") || crypto.randomUUID()
  ).current;

  localStorage.setItem("asportoSessionId", clientSessionId);

  const ordinePath = useMemo(() => collection(
    db,
    "ordiniAsportoTemp",
    normalizedLocaleTag,
    "sessions",
    clientSessionId,
    "items"
  ), [normalizedLocaleTag, clientSessionId]);

  // ===========================
  // STATI PRINCIPALI
  // ===========================
  const [aiOpen, setAiOpen] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [aiPreferences, setAiPreferences] = useState(null);
  const [infoLocale, setInfoLocale] = useState({});
  const [dishes, setDishes] = useState([]);
  // ===========================
  // MAPPA AVATAR CATEGORIE
  // ===========================
  const categoryAvatars = React.useMemo(() => {
    const map = {};

    if (!dishes || dishes.length === 0) return map;

    dishes.forEach((dish) => {
      if (dish.category && dish.image && !map[dish.category]) {
        map[dish.category] = dish.image;
      }
    });

    return map;
  }, [dishes]);

  const getCategoryAvatar = (catName) => {
    return categoryAvatars[catName] || null;
  };
  const [categorie, setCategorie] = useState([]);
  const [ordineCondiviso, setOrdineCondiviso] = useState([]);

  const [note, setNote] = useState("");
  const [inputValues, setInputValues] = useState({});
  const [clienteId, setClienteId] = useState("");

  const [loading, setLoading] = useState(true);
  const [notifLoading, setNotifLoading] = useState(false);
  
  // Inizializza lingua con priorità: localStorage → browser → "it"
  const [lingua, setLingua] = useState(() => {
    try {
      // 1) localStorage
      const saved = localStorage.getItem("qrzone_lingua");
      if (saved) return saved;
      
      // 2) browser language (primi 2 caratteri)
      const browserLang = navigator.language?.substring(0, 2);
      if (browserLang) return browserLang;
      
      // 3) fallback
      return "it";
    } catch {
      return "it";
    }
  });

  const [showRiepilogo, setShowRiepilogo] = useState(false);
  const [slotSelezionato, setSlotSelezionato] = useState("");
const [slotOccupazione, setSlotOccupazione] = useState({});
const [slotFullPopup, setSlotFullPopup] = useState(false);
  const [langDropdownOpen, setLangDropdownOpen] = useState(false);

  // AI

  // Popup immagine premium
  const [popupDish, setPopupDish] = useState(null);
 const [suggestionPopup, setSuggestionPopup] = useState({
  open: false,
  dish: null,
  suggestions: [],
  loading: false,
  quantity: 1,
  custom: "",
  asked: false
});

const [selectedSuggestions, setSelectedSuggestions] =
  useState(new Set());

  // Sponsor / Promo / Banners
  const [banners, setBanners] = useState([]);
  const [bannersPromozionali, setBannersPromozionali] = useState([]);
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const [currentBannerPromoIndex, setCurrentBannerPromoIndex] = useState(0);

  const [currentSponsor, setCurrentSponsor] = useState(null);
  const [showSponsor, setShowSponsor] = useState(false);

  const [currentPromozione, setCurrentPromozione] = useState(null);
  const [showPromozione, setShowPromozione] = useState(false);

  // OTP Bottom Sheet
  const [otpOpen, setOtpOpen] = useState(false);
  const [showConfirmSendPopup, setShowConfirmSendPopup] = useState(false);
  const [otpStep, setOtpStep] = useState("phone"); // phone | code | success
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneDigits, setPhoneDigits] = useState("");
  const [phoneDigitsConfirm, setPhoneDigitsConfirm] = useState("");
  const [otpCode, setOtpCode] = useState("");
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [phoneVerified, setPhoneVerified] = useState(false);
  const [loadingPhone, setLoadingPhone] = useState(false); // Loading per "Invia codice"
  const [loadingOtp, setLoadingOtp] = useState(false); // Loading per "Conferma"
const [userEditingPhone, setUserEditingPhone] = useState(false);

// Blocca invii multipli e mostra il popup di attesa
const [invioOrdineInCorso, setInvioOrdineInCorso] = useState(false);

  // Push Notifications
  const [fcmToken, setFcmToken] = useState(null);
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);
  const [forceNotifyPrompt, setForceNotifyPrompt] = useState(false);
  const [showNotifyExplain, setShowNotifyExplain] = useState(false);
  const [skipNotificationsOnce, setSkipNotificationsOnce] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showIosInstructions, setShowIosInstructions] = useState(false);
  const [showAndroidInstall, setShowAndroidInstall] = useState(false);

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isAndroid = /Android/.test(navigator.userAgent);
  const isStandalone =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  useEffect(() => {
    const isMobile = isAndroid || isIOS;

    if (!isMobile) return;
    if (isStandalone) return;

    const timer = setTimeout(() => {
      if (isIOS) {
        setShowIosInstructions(true);
      }

      if (isAndroid && deferredPrompt) {
        setShowAndroidInstall(true);
      }
    }, 3500);

    return () => clearTimeout(timer);
  }, [deferredPrompt]);

useEffect(() => {
  const restoreNotificationsState = async () => {
    const saved = localStorage.getItem(
      "qrmenu_notifications_completed"
    );

    if (saved !== "true") return;

    try {
      const messagingSupported = await isSupported();

      if (!messagingSupported) {
        console.warn(
          "Firebase Messaging non supportato su questo browser"
        );

        setNotificationsEnabled(false);
        setFcmToken(null);
        localStorage.removeItem(
          "qrmenu_notifications_completed"
        );

        return;
      }

      const messaging = getMessaging();
      const token = await getToken(messaging);

      if (!token) {
        setNotificationsEnabled(false);
        setFcmToken(null);

        localStorage.removeItem(
          "qrmenu_notifications_completed"
        );

        return;
      }

      setFcmToken(token);
      setNotificationsEnabled(true);
    } catch (err) {
      console.error(
        "Errore ripristino token notifiche:",
        err
      );

      setNotificationsEnabled(false);
      setFcmToken(null);
    }
  };

  restoreNotificationsState();
}, []);

  // Numero ordine progressivo
  const [numeroOrdine, setNumeroOrdine] = useState(null);
  const [ordiniInviati, setOrdiniInviati] = useState([]);

  // Snackbar
  const [snackbar, setSnackbar] = useState({
    visible: false,
    message: "",
    type: "info"
  });

  // Modalità dark/light auto
  const [isDarkMode, setIsDarkMode] = useState(false);

  // 📊 TRACKING ACCESSO MENU ASPORTO
useEffect(() => {
  const trackAsportoAccess = async () => {
    try {
      if (accessTrackedRef.current) return;

      const sessionKey =
        `analytics_asporto_${normalizedLocaleTag}_${clientSessionId}`;

      if (sessionStorage.getItem(sessionKey) === "true") {
        accessTrackedRef.current = true;
        return;
      }

      accessTrackedRef.current = true;

      await addDoc(collection(db, "analytics_asporto"), {
        localeTag: normalizedLocaleTag,
        sessionId: clientSessionId,
        timestamp: serverTimestamp(),
        userAgent: navigator.userAgent || null,
        language: navigator.language || null,
        platform: navigator.platform || null,
        standalone: isStandalone === true,
        source: "menu_asporto_opt"
      });

      sessionStorage.setItem(sessionKey, "true");

      console.log("📊 Accesso MenuAsportoOpt registrato");
    } catch (err) {
      console.error("❌ Errore tracking asporto:", err);
    }
  };

  trackAsportoAccess();
}, [normalizedLocaleTag, clientSessionId, isStandalone]);

  // Categoria selezionata dalla navbar
  const [activeCategory, setActiveCategory] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);

  // Ref per sidebar auto-scroll
  const sidebarRef = useRef(null);

  const accessTrackedRef = useRef(false);

  // Ref per reCAPTCHA (evita inizializzazione prematura)
  const recaptchaVerifierRef = useRef(null);

  // Ref per input telefono e OTP (forceFocus workaround)
  const phoneInputRef = useRef(null);
  const otpInputRef = useRef(null);
// Blocco sincrono contro doppi clic
const invioOrdineLockRef = useRef(false);
  // ===========================
  // TRADUZIONI
  // ===========================

  const [uiTranslations, setUiTranslations] = useState({});

  const t = {
    it: defaultUIStrings,
    en: {
      loading: "Loading...",
      allergens: "Allergens",
      placeholder: "E.g. without onion",
      add: "Add",
      callService: "Call service",
      orderSummary: "Order summary",
      sendOrder: "Send order",
      close: "Close",
      notesPlaceholder: "Extra notes...",
      sentOrders: "Sent orders",
      aiAssistantTitle: "AI Assistant",
      aiPostOrderTitle: "AI Chef suggestion",
      aiPostOrderClose: "Got it",
      itemAdded: "Item added to cart",
      orderSent: "Order sent to the kitchen"
    }
  };

  const TT = uiTranslations[lingua] || t[lingua] || t.it;

  // ===============================
  // Microcopy fallback (UI safety)
  // ===============================
  const microcopyFallback = {
    it: {
      recommendedBadge: "Consigliato",
      notesHintPlaceholder: "Nota (es. senza cipolla)",
      addToOrderA11y: "Aggiungi al tuo ordine",
      removedFromOrder: "Rimosso dal tuo ordine",
      addError: "Non sono riuscito ad aggiungerlo",
      suggestionPopupTitle: "Vuoi un consiglio veloce?",
      suggestionYes: "Sì, consigliami",
      suggestionNo: "No, solo questo",
      suggestionLoading: "Sto cercando gli abbinamenti migliori...",
      addSelectionCta: "✅ Aggiungi selezione",
      onlyDishCta: "➕ Solo il piatto"
    },
    en: {
      recommendedBadge: "Recommended",
      notesHintPlaceholder: "Note (e.g. no onion)",
      addToOrderA11y: "Add to your order",
      removedFromOrder: "Removed from your order",
      addError: "Couldn’t add it"
    }
  };

  // Helper per recuperare testo UI con fallback sicuro
  const TXT = (key) =>
    TT?.[key] ||
    microcopyFallback?.[lingua]?.[key] ||
    microcopyFallback.it[key] ||
    key;

  // ===========================
  // UTIL SNACKBAR
  // ===========================

  const showSnack = (message, type = "info", duration = 3000) => {
    setSnackbar({ visible: true, message, type });
    setTimeout(() => {
      setSnackbar({ visible: false, message: "", type: "info" });
    }, duration);
  };



  // ===========================
  // TOTALE PIATTI CARRELLO
  // ===========================

  const totalePiatti = ordineCondiviso.reduce(
    (acc, item) => acc + (item.quantity || 0),
    0
  );

  const asportoSlotsConfig = infoLocale?.asportoSlots || {};
const slotAsportoEnabled = asportoSlotsConfig?.enabled === true;

const oggiSlotKey = new Date().toISOString().slice(0, 10);

const timeToMinutes = (time) => {
  const [h, m] = String(time || "00:00")
    .split(":")
    .map(Number);

  return h * 60 + m;
};

const minutesToTime = (minutes) => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;

  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
};

const getSlotId = (slot) =>
  String(slot).replace(":", "-");

const slotsDisponibili = useMemo(() => {
  if (!slotAsportoEnabled) return [];

  const start = timeToMinutes(
    asportoSlotsConfig.oraInizio || "19:30"
  );

  const end = timeToMinutes(
    asportoSlotsConfig.oraFine || "23:00"
  );

  const step = Number(
    asportoSlotsConfig.intervalloMinuti || 15
  );

  const result = [];

  for (let t = start; t <= end; t += step) {
    result.push(minutesToTime(t));
  }

  return result;
}, [slotAsportoEnabled, asportoSlotsConfig]);

const maxPezziPerSlot = Number(
  asportoSlotsConfig.maxPezziPerSlot || 10
);

const getOccupatiSlot = (slot) => {
  return Number(
    slotOccupazione?.[getSlotId(slot)] || 0
  );
};

const isSlotCompleto = (slot) => {
  return getOccupatiSlot(slot) >= maxPezziPerSlot;
};

  // ===========================
  // TOTALE PER SINGOLO PIATTO
  // ===========================

  const getTotalQuantityForDish = (dishId) => {
    return ordineCondiviso
      .filter((item) => item.dishId === dishId)
      .reduce((sum, item) => sum + (item.quantity || 0), 0);
  };

  // ===========================
  // LINGUE DISPONIBILI
  // ===========================

  const availableLangs = React.useMemo(() => {
    const langSet = new Set(["it"]); // sempre "it" come fallback
    
    dishes.forEach((dish) => {
      // Legge da translations
      if (dish.translations && typeof dish.translations === "object") {
        Object.keys(dish.translations).forEach((lang) => {
          langSet.add(lang);
        });
      }
      
      // Legge da nome
      if (dish.nome && typeof dish.nome === "object") {
        Object.keys(dish.nome).forEach((lang) => {
          langSet.add(lang);
        });
      }
      
      // Legge da descrizione
      if (dish.descrizione && typeof dish.descrizione === "object") {
        Object.keys(dish.descrizione).forEach((lang) => {
          langSet.add(lang);
        });
      }
    });

    const langs = Array.from(langSet);
    // "it" per primo, poi altre lingue in ordine alfabetico
    return ["it", ...langs.filter((l) => l !== "it").sort()];
  }, [dishes]);

  // Mappa delle bandiere per le lingue (codici ISO 639-1)
  const langFlags = {
    it: "🇮🇹",
    en: "🇬🇧",
    fr: "🇫🇷",
    de: "🇩🇪",
    es: "🇪🇸",
    pt: "🇵🇹",
  };

  // ===========================
  // UseEffect + Firebase
  // ===========================

  // Salva lingua selezionata nel localStorage
  useEffect(() => {
    try {
      localStorage.setItem("qrzone_lingua", lingua);
    } catch (error) {
      console.error("Errore salvataggio lingua:", error);
    }
  }, [lingua]);

  // Isola scroll touch della sidebar per evitare propagazione al body
  useEffect(() => {
    const sidebar = document.querySelector(".mv-sidebar-inner");
    if (!sidebar) return;

    const stopTouch = (e) => {
      e.stopPropagation();
    };

    sidebar.addEventListener("touchstart", stopTouch, { passive: true });
    sidebar.addEventListener("touchmove", stopTouch, { passive: true });

    return () => {
      sidebar.removeEventListener("touchstart", stopTouch);
      sidebar.removeEventListener("touchmove", stopTouch);
    };
  }, []);

  // ========================================
// CALCOLO DINAMICO HEIGHT APP-LIKE
// ========================================

useEffect(() => {
  const updateLayoutHeights = () => {

    // TOPBAR
    const topbar = document.querySelector(".categoria-nav");
    const topbarHeight = topbar?.offsetHeight || 64;

    document.documentElement.style.setProperty(
      "--topbar-height",
      `${topbarHeight}px`
    );

    // BANNER
    const banner = document.querySelector(".mv-banner-wrapper");
    const bannerHeight = banner?.offsetHeight || 0;

    document.documentElement.style.setProperty(
      "--banner-height",
      `${bannerHeight}px`
    );

    // CATEGORIE
    const categories = document.querySelector(".mv-sidebar");
    const categoriesHeight = categories?.offsetHeight || 74;

    document.documentElement.style.setProperty(
      "--categories-height",
      `${categoriesHeight}px`
    );
  };

  updateLayoutHeights();

  window.addEventListener("resize", updateLayoutHeights);

  const observer = new ResizeObserver(() => {
    updateLayoutHeights();
  });

  const banner = document.querySelector(".mv-banner-wrapper");
  const categories = document.querySelector(".mv-sidebar");
  const topbar = document.querySelector(".categoria-nav");

  if (banner) observer.observe(banner);
  if (categories) observer.observe(categories);
  if (topbar) observer.observe(topbar);

  return () => {
    window.removeEventListener("resize", updateLayoutHeights);
    observer.disconnect();
  };
}, [banners, categorie, loading]);

  // Dark / Light mode automatica
  useEffect(() => {
    try {
      const mq = window.matchMedia("(prefers-color-scheme: dark)");
      const update = (e) => setIsDarkMode(e.matches);
      setIsDarkMode(mq.matches);

      if (mq.addEventListener) mq.addEventListener("change", update);
      else mq.addListener(update);

      return () => {
        if (mq.removeEventListener) mq.removeEventListener("change", update);
        else mq.removeListener(update);
      };
    } catch {
      setIsDarkMode(false);
    }
  }, []);

  // Genera ID cliente unico
  useEffect(() => {
    const generateUUID = () => {
      if (crypto.randomUUID) return crypto.randomUUID();
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    };

    const id = localStorage.getItem("clienteId") || generateUUID();
    localStorage.setItem("clienteId", id);
    setClienteId(id);
  }, []);

  // Mostra riepilogo se arriva da notifica push (orderId in query string)
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const orderIdParam = params.get("orderId");
      if (orderIdParam) {
        setShowRiepilogo(true);
      }
    } catch (err) {
      console.error("Errore lettura orderId da URL:", err);
    }
  }, []);

  // Carica numero ordine da localStorage
  useEffect(() => {
    const savedNumero = localStorage.getItem(`ordineAsportoOpt_${normalizedLocaleTag}`);
    if (savedNumero) {
      setNumeroOrdine(parseInt(savedNumero, 10));
    }
  }, [normalizedLocaleTag]);

  // Listener per ordini inviati (tracking)
  useEffect(() => {
    if (!numeroOrdine) return;

    const q = query(
      collection(db, "ordini"),
      where("numeroOrdineAsporto", "==", numeroOrdine),
      where("locale", "==", normalizedLocaleTag)
    );

const unsubscribe = onSnapshot(q, (snapshot) => {
  const ordini = snapshot.docs
    .map(doc => ({ id: doc.id, ...doc.data() }))
    .filter(
      ordine =>
        ordine.stato !== "pagamento" &&
        ordine.stato !== "archiviato"
    );

  setOrdiniInviati(ordini);

  const ordineAttivo = ordini.find(
    ordine => ordine.stato === "inviato"
  );

  if (ordineAttivo?.slotAsporto) {
    setSlotSelezionato(ordineAttivo.slotAsporto);
  } else {
    setSlotSelezionato("");
  }
});

    return () => unsubscribe();
  }, [numeroOrdine, normalizedLocaleTag]);

  // Fetch info locale
  useEffect(() => {
    const ref = doc(db, "locali", normalizedLocaleTag);
    const unsub = onSnapshot(
      ref,
      (snap) => {
        if (snap.exists()) setInfoLocale(snap.data());
      },
      (e) => console.error("Errore infoLocale:", e)
    );
    return () => unsub();
  }, [normalizedLocaleTag]);

  // Listener realtime occupazione slot asporto
useEffect(() => {
  if (!slotAsportoEnabled) {
    setSlotOccupazione({});
    setSlotSelezionato("");
    return;
  }

  const ref = doc(
    db,
    "asporto_slot_occupazione",
    `${normalizedLocaleTag}_${oggiSlotKey}`
  );

  const unsub = onSnapshot(ref, (snap) => {
    if (!snap.exists()) {
      setSlotOccupazione({});
      return;
    }

    setSlotOccupazione(snap.data().slots || {});
  });

  return () => unsub();
}, [slotAsportoEnabled, normalizedLocaleTag, oggiSlotKey]);

  // Fetch menu + categorie
  useEffect(() => {
    const fetchMenu = async () => {
      setLoading(true);
      try {
        const qMenu = query(
          collection(db, "menu"),
          where("localeTag", "==", normalizedLocaleTag)
        );

        const snapMenu = await getDocs(qMenu);
        const items = snapMenu.docs
          .map((d) => {
            const data = d.data();
            // Gestisce nome e descrizione come oggetti multilingua o stringhe legacy
            const nomeObj = typeof data.nome === 'object' ? data.nome : { it: data.nome || "" };
            const descObj = typeof data.descrizione === 'object' ? data.descrizione : { it: data.descrizione || "" };
            
            return {
              id: d.id,
              translations: data.translations || {},
              nome: nomeObj,
              descrizione: descObj,
              price: parseFloat(String(data.prezzo).replace(",", ".")) || 0,
              image: data.immagineUrl || "",
              category: data.categoria || "Altro",
              allergeni: Array.isArray(data.allergeni)
                ? data.allergeni
                : (typeof data.allergeni === "string"
                    ? data.allergeni.split(",").map(a => a.trim()).filter(Boolean)
                    : []),
              ingredienti: Array.isArray(data.ingredienti)
                ? data.ingredienti
                : (typeof data.ingredienti === "string"
                    ? data.ingredienti.split(",").map(i => i.trim()).filter(Boolean)
                    : []),
              visibile: data.visibile !== false,
              inPromozione: data.inPromozione === true,
              ordine: data.ordine || 0
            };
          })
          .filter((x) => x.visibile);

        const snapCat = await getDocs(collection(db, "categorie"));
        const cats = snapCat.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          .filter(
            (c) => c.localeTag === normalizedLocaleTag && c.visibile !== false
          )
          .sort((a, b) => (a.ordine || 0) - (b.ordine || 0));

        setDishes(items);
        setCategorie(cats);
      } catch (e) {
        console.error("Errore menu:", e);
        showSnack(TT.menuLoadError, "error");
      } finally {
        setLoading(false);
      }
    };
    fetchMenu();
  }, [normalizedLocaleTag]);

  // Fetch traduzioni UI da Firestore
  useEffect(() => {
    const fetchUITranslations = async () => {
      try {
        const uiTransRef = doc(db, "restaurants", normalizedLocaleTag, "ai", "uiTranslations");
        const snap = await getDoc(uiTransRef);

        if (snap.exists()) {
          setUiTranslations(snap.data());
        }
      } catch (e) {
        console.error("Errore caricamento traduzioni UI:", e);
      }
    };

    fetchUITranslations();
  }, [normalizedLocaleTag]);

  // ── MANIFEST DINAMICO ──────────────────────────────────────────
  // Attende che infoLocale sia caricato prima di generare il manifest,
  // così il nome del locale e la start_url sono sempre corretti.
  useEffect(() => {
    if (!normalizedLocaleTag) return;

    // Usa il dominio corrente (funziona su qrmenu-italia.it e su web.app)
    const origin = window.location.origin;
    const startUrl = `${origin}/menu-asporto-opt/${normalizedLocaleTag}`;
    const scope    = `${origin}/menu-asporto-opt/`;

    // Nome: aspetta infoLocale; se non ancora pronto usa fallback
    const nomeBreve = infoLocale?.nomeLocale || "Ordina";
    const nomeLungo = infoLocale?.nomeLocale
      ? `${infoLocale.nomeLocale} – Ordina`
      : "QrMenu – Asporto";

    const dynamicManifest = {
      id:          startUrl,
      short_name:  nomeBreve,
      name:        nomeLungo,
      description: "Ordina da asporto e ricevi notifiche sullo stato dell'ordine",
      start_url:   startUrl,
      scope:       scope,
      display:     "standalone",
      display_override: ["standalone", "minimal-ui"],
      orientation: "portrait",
      background_color: "#111111",
      theme_color:      "#111111",
      icons: [
        { src: `${origin}/icons/icon-192.png`, sizes: "192x192", type: "image/png", purpose: "any maskable" },
        { src: `${origin}/icons/icon-512.png`, sizes: "512x512", type: "image/png", purpose: "any maskable" }
      ]
    };

    const blob = new Blob(
      [JSON.stringify(dynamicManifest)],
      { type: "application/json" }
    );
    const blobUrl = URL.createObjectURL(blob);

    let link = document.querySelector("link[rel='manifest']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "manifest";
      document.head.appendChild(link);
    }

    const prevUrl = link.href;
    link.href = blobUrl;
    if (prevUrl?.startsWith("blob:")) URL.revokeObjectURL(prevUrl);

    // Aggiorna anche <title> e <meta name="apple-mobile-web-app-title">
    document.title = nomeBreve;
    let appleMeta = document.querySelector("meta[name='apple-mobile-web-app-title']");
    if (!appleMeta) {
      appleMeta = document.createElement("meta");
      appleMeta.name = "apple-mobile-web-app-title";
      document.head.appendChild(appleMeta);
    }
    appleMeta.content = nomeBreve;

    return () => URL.revokeObjectURL(blobUrl);
  }, [normalizedLocaleTag, infoLocale?.nomeLocale]);
  // ────────────────────────────────────────────────────────────────

  // Fetch preferenze AI (piatti da spingere, regole)
  useEffect(() => {
    const fetchAIPreferences = async () => {
      try {
        const prefsRef = doc(db, 'ai_settings', normalizedLocaleTag);
        const prefsSnap = await getDoc(prefsRef);
        if (prefsSnap.exists()) {
          setAiPreferences(prefsSnap.data());
        } else {
          setAiPreferences(null);
        }
      } catch (e) {
        console.error('Errore caricamento preferenze AI:', e);
      }
    };
    fetchAIPreferences();
  }, [normalizedLocaleTag]);

  // Fetch banner
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const snap = await getDocs(collection(db, "banners"));
        const attivi = snap.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          .filter(
            (b) =>
              b.localeTag?.toLowerCase() === normalizedLocaleTag.toLowerCase() &&
              b.attivo === true
          )
          .sort(
            (a, b) => (b.timestamp?.seconds || 0) - (a.timestamp?.seconds || 0)
          );

        setBanners(attivi);
      } catch (e) {
        console.error("Errore banners:", e);
      }
    };
    fetchBanners();
  }, [normalizedLocaleTag]);

  useEffect(() => {
    if (banners.length <= 1) return;
    const id = setInterval(
      () => setCurrentBannerIndex((i) => (i + 1) % banners.length),
      5000
    );
    return () => clearInterval(id);
  }, [banners.length]);

  // Fetch banner promozionali
  useEffect(() => {
    const fetchBannersPromozionali = async () => {
      try {
        const snap = await getDocs(collection(db, "banners_promozionali"));
        const attivi = snap.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          .filter(
            (b) =>
              b.localeTag?.toLowerCase() === normalizedLocaleTag.toLowerCase() &&
              b.attivo === true
          )
          .sort(
            (a, b) => (b.timestamp?.seconds || 0) - (a.timestamp?.seconds || 0)
          );

        setBannersPromozionali(attivi);
      } catch (e) {
        console.error("Errore banners promo:", e);
      }
    };
    fetchBannersPromozionali();
  }, [normalizedLocaleTag]);

  useEffect(() => {
    if (bannersPromozionali.length <= 1) return;
    const id = setInterval(
      () =>
        setCurrentBannerPromoIndex(
          (i) => (i + 1) % bannersPromozionali.length
        ),
      5000
    );
    return () => clearInterval(id);
  }, [bannersPromozionali.length]);

  // ========================================
// AUTO POPUP SPONSOR
// ========================================

useEffect(() => {
  if (!banners.length) return;

  const sponsorAttivi = banners.filter(
    (b) =>
      b.mostraComePopup === true &&
      b.imageUrl
  );

  if (!sponsorAttivi.length) return;

  const timeout = setTimeout(() => {
    const sponsor =
      sponsorAttivi[
        Math.floor(Math.random() * sponsorAttivi.length)
      ];

    setCurrentSponsor(sponsor);
    setShowSponsor(true);
  }, 5000);

  return () => clearTimeout(timeout);
}, [banners]);

// ========================================
// AUTO POPUP PROMO
// ========================================

useEffect(() => {
  if (!bannersPromozionali.length) return;

  const promoAttive = bannersPromozionali.filter(
    (b) =>
      b.mostraComePopup === true &&
      b.imageUrl
  );

  if (!promoAttive.length) return;

  const timeout = setTimeout(() => {
    const promo =
      promoAttive[
        Math.floor(Math.random() * promoAttive.length)
      ];

    setCurrentPromozione(promo);
    setShowPromozione(true);
  }, 9000);

  return () => clearTimeout(timeout);
}, [bannersPromozionali]);

  // Fetch promozioni popup (piatto in evidenza) — identico a MenuView
  useEffect(() => {
    const fetchPromos = async () => {
      try {
        const snap = await getDocs(collection(db, "promozioni"));
        const list = snap.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          .filter(
            (p) =>
              p.localeTag?.toLowerCase() === normalizedLocaleTag.toLowerCase() &&
              p.attivo === true
          );

        setCurrentPromozione(null);
        setShowPromozione(false);

        if (list.length > 0) {
          setTimeout(() => {
            setCurrentPromozione(list[0]);
            setShowPromozione(true);
          }, 4000);
        }
      } catch (e) {
        console.error("Errore promozioni:", e);
      }
    };

    fetchPromos();
  }, [normalizedLocaleTag]);

  // Carrello live
  useEffect(() => {
    const ref = ordinePath;
    const unsub = onSnapshot(ref, (snap) => {
      const lista = snap.docs
        .map((d) => ({ id: d.id, ...d.data() }))
        .sort((a, b) => a.name.localeCompare(b.name));

      setOrdineCondiviso(lista);
    });
    return () => unsub();
  }, [ordinePath]);

  // Auto-scroll sidebar per mantenere categoria attiva visibile
  useEffect(() => {
    if (!sidebarRef.current || !activeCategory) return;

    const container = sidebarRef.current;
    const activeBtn = container.querySelector(
      `[data-cat="${activeCategory}"]`
    );

    if (!activeBtn) return;

    const containerRect = container.getBoundingClientRect();
    const btnRect = activeBtn.getBoundingClientRect();

    const offset =
  btnRect.left -
  containerRect.left -
  containerRect.width / 2 +
  btnRect.width / 2;

container.scrollTo({
  left: container.scrollLeft + offset,
  behavior: "smooth",
});
  }, [activeCategory]);

  // IntersectionObserver per evidenziare categoria attiva durante lo scroll
  useEffect(() => {
    if (loading) return;
    if (selectedCategory) return;

    const titles = document.querySelectorAll(".mv-section-title");
    if (!titles.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter(e => e.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

        if (visible.length > 0) {
          const container = document.querySelector(".mv-main");
          if (container && container.scrollTop < 80) {
            setActiveCategory(null);
            return;
          }
          const id = visible[0].target.id;
          if (id?.startsWith("cat-")) {
            setActiveCategory(id.replace("cat-", ""));
          }
        }
      },
      {
        root: document.querySelector(".mv-main"),
        rootMargin: "-40% 0px -50% 0px",
        threshold: 0
      }
    );

    titles.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [selectedCategory, loading, categorie.length]);

  // ====== AUTO FOCUS OTP INPUTS ======
  useEffect(() => {
    if (otpOpen && otpStep === "phone" && !userEditingPhone && !phoneDigits) {
      forceFocus(phoneInputRef);
    } else if (otpOpen && otpStep === "code") {
      forceFocus(otpInputRef);
    }
  }, [otpOpen, otpStep, userEditingPhone]);

  // ===========================
  // INPUT HANDLERS
  // ===========================


  // ===========================
  // Risolve nome categoria con fallback
  // ===========================
  const resolveCategoryName = (cat, lingua) => {
    if (lingua === "it") return cat.nome || "";

    return (
      cat.translations?.[lingua]?.name ||
      cat.nome ||
      ""
    );
  };

  const handleInputChange = (dishId, field, value) => {
    setInputValues((prev) => ({
      ...prev,
      [dishId]: {
        ...(prev[dishId] || { quantity: 1, custom: "" }),
        [field]: value
      }
    }));
  };

  // Aggiungi al carrello
const aggiungiItemTemp = async (dish) => {
  if (infoLocale?.nascondiAI === true || infoLocale?.suggerimentiAI === false) {
    const values = inputValues[dish.id] || { quantity: 1, custom: "" };
    const custom = values.custom ? String(values.custom).trim() : "";
    await addDishToCart(dish, 1, custom);
    return;
  }

  const values = inputValues[dish.id] || { quantity: 1, custom: "" };
  const custom = values.custom ? String(values.custom).trim() : "";
  const quantity = 1;

  const normalize = (s) => String(s || "").trim().toLowerCase();
  const regole = aiPreferences?.regole_suggerimenti || {};
  const categoriaPiatto = normalize(dish.category || dish.categoria);

  let categorieSuggerite =
    Object.entries(regole)
      .find(([cat]) => normalize(cat) === categoriaPiatto)?.[1] || [];

  const intensita = aiPreferences?.intensita || "moderata";

  if (intensita === "soft") {
    if (Math.random() < 0.6) {
      await addDishToCart(dish, quantity, custom);
      return;
    }
  }

  if (intensita === "aggressiva") {
    if (!categorieSuggerite.length) {
      categorieSuggerite = [
        ...new Set(
          Object.values(regole || {})
            .flat()
            .map(c => normalize(c))
            .filter(c => c && c !== categoriaPiatto)
        )
      ];
    }
  }

  if (!categorieSuggerite || categorieSuggerite.length === 0) {
    await addDishToCart(dish, quantity, custom);
    return;
  }

  setSelectedSuggestions(new Set());

  setSuggestionPopup({
    open: true,
    dish,
    quantity,
    custom,
    suggestions: [],
    loading: false,
    asked: false
  });
};

  // ====== FORCE FOCUS WORKAROUND (mobile keyboard) ======
  const forceFocus = (ref) => {
    setTimeout(() => {
      if (ref?.current && document.activeElement !== ref.current) {
        ref.current.focus({ preventScroll: true });
      }
    }, 120);
  };

  // ====== OTP / reCAPTCHA FIX ======
  const getRecaptchaVerifier = () => {
    if (!recaptchaVerifierRef.current) {
      recaptchaVerifierRef.current = new RecaptchaVerifier(
        auth,
        "recaptcha-container",
        {
          size: "invisible",
          callback: () => {},
        }
      );
    }
    return recaptchaVerifierRef.current;
  };

  // Invia OTP via SMS
  const sendOtp = async () => {
    if (!ENABLE_OTP) return;

    const cleanPhone = (v) => v.replace(/\D/g, "");

    const phoneA = cleanPhone(phoneDigits);
    const phoneB = cleanPhone(phoneDigitsConfirm);

    if (phoneA !== phoneB) {
      alert("I numeri di telefono non coincidono");
      return;
    }

    if (phoneA.length < 9) {
      alert("Inserisci un numero di telefono valido");
      return;
    }

    setLoadingPhone(true);
    const phoneNumber = `+39${phoneA}`;

    try {
      // Inizializza reCAPTCHA SOLO qui, quando si preme "Invia codice"
      if (!recaptchaVerifierRef.current) {
        recaptchaVerifierRef.current = new RecaptchaVerifier(
          auth,
          "recaptcha-container",
          {
            size: "invisible",
            callback: () => {},
          }
        );
      }

      const appVerifier = recaptchaVerifierRef.current;

      const result = await signInWithPhoneNumber(
        auth,
        phoneNumber,
        appVerifier
      );

      setPhoneNumber(phoneNumber);
      setConfirmationResult(result);
      setOtpStep("code");
    } catch (err) {
      console.error("Errore invio OTP:", err);
      alert("Errore nell'invio del codice. Riprova.");

      if (recaptchaVerifierRef.current) {
        recaptchaVerifierRef.current.clear();
        recaptchaVerifierRef.current = null;
      }
    } finally {
      setLoadingPhone(false);
    }
  };

  // Verifica OTP
  const verifyOtp = async () => {
    if (!ENABLE_OTP) return;

    setLoadingOtp(true);

    try {
      if (!confirmationResult) {
        alert("Richiedi prima il codice.");
        return;
      }
      await confirmationResult.confirm(otpCode);
      setPhoneVerified(true);
      setOtpOpen(false);
      setPhoneDigits("");
      setPhoneDigitsConfirm("");
      setShowRiepilogo(false);

      // OTP verificato → invia ordine direttamente
      await inviaOrdineFinale();
    } catch (err) {
      console.error("OTP non valido:", err);
      alert("Codice non valido");
    } finally {
      setLoadingOtp(false);
    }
  };

  // ===========================
  // NOTIFICHE PUSH
  // ===========================
  const handleEnableNotificationsSmart = async () => {

    // ANDROID NON INSTALLATA -> INSTALLA
    if (isAndroid && !isStandalone && deferredPrompt) {
      deferredPrompt.prompt();
      const choice = await deferredPrompt.userChoice;

      if (choice.outcome === "accepted") {
        setDeferredPrompt(null);
      }

      return;
    }

    // IOS NON INSTALLATA -> ISTRUZIONI
    if (isIOS && !isStandalone) {
      setShowIosInstructions(true);
      return;
    }

    // SE GIA INSTALLATA -> ATTIVA NOTIFICHE NORMALI
    enableNotificationsManually();
  };

  const enableNotificationsManually = async () => {
    try {
      const messagingSupported = await isSupported();

if (!messagingSupported) {
  showSnack(
    "Le notifiche non sono supportate in questo browser. Su iPhone aggiungi QrMenu alla schermata Home e aprilo dall’icona.",
    "error",
    5000
  );

  return;
}

      if (!("Notification" in window)) {
        showSnack("Notifiche non supportate", "error");
        return;
      }

      const permission = await Notification.requestPermission();

      if (permission !== "granted") {
        showSnack("Permesso notifiche negato", "error");
        return;
      }

      const messaging = getMessaging();
      // Protezione importante
      if (!messaging) {
        showSnack("Errore inizializzazione notifiche", "error");
        return;
      }

      const token = await getToken(messaging);

      if (!token) {
        showSnack("Impossibile ottenere token notifiche", "error");
        return;
      }

      console.log("🔥 FCM TOKEN:", token);

      setFcmToken(token);
      setNotificationsEnabled(true);
      localStorage.setItem("qrmenu_notifications_completed", "true");
      setForceNotifyPrompt(false);

      showSnack("🔔 Notifiche attivate!", "success");
    } catch (err) {
      console.error("Errore FCM:", err);
      showSnack("Errore attivazione notifiche", "error");
    }
  };

  // ===========================
  // HELPER ICONE CATEGORIA
  // ===========================
  const getCategoryIcon = (name = "") => {
    const n = String(name).toLowerCase();
    if (n.includes("pizza")) return "🍕";
    if (n.includes("primi")) return "🍝";
    if (n.includes("second")) return "🍖";
    if (n.includes("dolc")) return "🍰";
    if (n.includes("bev")) return "🥤";
    if (n.includes("anti")) return "🥗";
    if (n.includes("promo")) return "⭐";
    return "🍽️";
  };

  // ===========================
  // CARD COMPATTA - NUOVA STRUTTURA
  // Foto+Prezzo a sinistra | Info+Note/Pulsante a destra
  // ===========================

  const renderDishCard = (dish) => {

    const values = inputValues[dish.id] || { quantity: 1, custom: "" };
    const totalQtyForDish = getTotalQuantityForDish(dish.id);
    const { name, description, ingredients } = resolveDishText(dish, lingua);
    // menuConFoto: true di default se non impostato esplicitamente a false
    const conFoto = infoLocale.menuConFoto !== false;

    // Calcola badge promo/chef — identico a MenuView
    const isSpinto = aiPreferences?.piatti_da_spingere?.some(p => {
      if (p.id && dish.id) return p.id === dish.id;
      const pn = String(typeof p.nome === "string" ? p.nome : p.nome?.it || p).toLowerCase().trim();
      const dn = String(typeof dish.nome === "string" ? dish.nome : dish.nome?.it).toLowerCase().trim();
      return pn === dn || dn.includes(pn) || pn.includes(dn);
    });
    const promoBadge = dish.inPromozione
      ? "🔥 Promo"
      : isSpinto
      ? "⭐ Chef"
      : null;

    // Suggerimenti inline
    const getInlineSuggestionsAsporto = (d) => {
      if (!dishes?.length) return [];
      const normalize = (s) => String(s || "").toLowerCase().trim();
      const categoriaPiatto = normalize(d.category || d.categoria);
      if (categoriaPiatto === "bevande") return [];
      const candidati = dishes.filter(c => {
        if (c.id === d.id) return false;
        const cat = normalize(c.category || c.categoria);
        return cat !== categoriaPiatto && cat !== "bevande";
      });
      if (!candidati.length) return [];
      return candidati.slice(0, 2);
    };

    return (
      <div
        key={dish.id}
        className={`dish-card${conFoto ? "" : " no-foto"}`}
        onClick={(e) => {
          if (e.target.closest("input") || e.target.closest("button")) return;
          setPopupDish(dish);
        }}
        style={{ cursor: "pointer" }}
      >
        {/* ── COLONNA SINISTRA: FOTO + badge promo SOTTO ── */}
        {conFoto && (
          <div className="dish-img-col">
            <div className="dish-image-wrapper">
              {dish.image ? (
                <img src={dish.image} alt={name} className="dish-image" />
              ) : (
                <div className="dish-no-image">🍽️</div>
              )}
              {totalQtyForDish > 0 && (
                <div className="dish-badge-overlay">{totalQtyForDish}</div>
              )}
            </div>
            {/* badge promo/chef SOTTO la foto */}
            {promoBadge && (
              <span className="promo-pill promo-pill--photo">{promoBadge}</span>
            )}
          </div>
        )}

        {/* ── COLONNA DESTRA: INFO ── */}
        <div className="dish-info-col">

          {/* RIGA 1: nome + badge quantità (no-foto) + prezzo */}
          <div className="dish-header-row">
            <span className="dish-name">{name}</span>
            {!conFoto && totalQtyForDish > 0 && (
              <span className="dish-badge-inline">{totalQtyForDish}</span>
            )}
            <span className="dish-price">{(dish.price || 0).toFixed(2)} €</span>
          </div>

          {/* RIGA 2: badge promo solo in no-foto */}
          {!conFoto && promoBadge && (
            <span className="promo-pill">{promoBadge}</span>
          )}

          {/* RIGA 3: descrizione */}
          {description && (
            <p className="dish-desc">{description}</p>
          )}

          {/* RIGA 4: suggerimenti inline */}
          {(() => {
            const suggerimenti = getInlineSuggestionsAsporto(dish);
            if (!suggerimenti.length) return null;
            return (
              <div className="inline-suggestions">
                <span className="inline-suggestions-label">Abbina con:</span>
                <div className="inline-suggestions-list">
                  {suggerimenti.map((s) => {
                    const nome = typeof s.nome === "string" ? s.nome : s.nome?.it || "";
                    return (
                      <span key={s.id} className="inline-suggestion-pill">
                        {nome}
                      </span>
                    );
                  })}
                </div>
              </div>
            );
          })()}

          {/* RIGA 5: note + pulsante aggiungi */}
          {infoLocale.consentOrdine && (
            <div className="dish-action-row">
              <input
                type="text"
                className="note-input"
                placeholder={TT.notesHintPlaceholder || "Es: senza cipolla"}
                value={values.custom}
                onChange={(e) => handleInputChange(dish.id, "custom", e.target.value)}
              />
              <button
                type="button"
                className="add-btn"
                onClick={() => aggiungiItemTemp(dish)}
                aria-label={TT.addToOrderA11y || "Aggiungi all'ordine"}
              >
                +
              </button>
            </div>
          )}

        </div>
      </div>
    );
  };

  // ===========================
  // Popup immagine premium
  // ===========================

  const PopupDish = () => {

    if (!popupDish) return null;

    const values = inputValues[popupDish.id] || {
      quantity: 1,
      custom: ""
    };

    const { name: resolvedName, description: resolvedDescription, ingredients } = resolveDishText(popupDish, lingua);
    const allergensForView = resolveAllergensForView(popupDish, lingua);

    return (
      <div
        className="popup-overlay"
        onClick={() => setPopupDish(null)}
      >
        <div
          className="popup-content"
          onClick={(e) => e.stopPropagation()}
        >
          {popupDish.image && (
            <img
              src={popupDish.image}
              alt={resolvedName}
              className="popup-image"
            />
          )}

          <div className="popup-info">
            <h2 className="popup-title">
              {resolvedName}
            </h2>

            {resolvedDescription && (
              <p className="popup-desc">
                {resolvedDescription}
              </p>
            )}

            {Array.isArray(ingredients) && ingredients.length > 0 && (
              <div className="popup-ingredients">
                <strong>Ingredienti:</strong>
                <p>{ingredients.join(", ")}</p>
              </div>
            )}

            {Array.isArray(allergensForView) && allergensForView.length > 0 && (
              <div className="popup-allergens">
                <strong>⚠️ {TT.allergens}:</strong>
                <div className="popup-allergen-list">
                  {allergensForView.map((a) => (
                    <span key={a} className="popup-allergen-badge">{a}</span>
                  ))}
                </div>
              </div>
            )}

            <div className="popup-price">
              {(popupDish.price || 0).toFixed(2)} €
              {popupDish.inPromozione && (
                <span className="promo-pill">🔥 Promo</span>
              )}
            </div>

            {infoLocale.consentOrdine && (
              <>
                <input
                  className="popup-note-input"
                  type="text"
                  placeholder={TT.notesHintPlaceholder || "Es: senza cipolla, ben cotto..."}
                  value={values.custom}
                  onChange={(e) =>
                    handleInputChange(
                      popupDish.id,
                      "custom",
                      e.target.value
                    )
                  }
                />

                <button
                  className="popup-add-btn"
                  onClick={() => {
                    aggiungiItemTemp(popupDish);
                    setPopupDish(null);
                  }}
                >
                  + {TT.add}
                </button>
              </>
            )}

            <button
              className="popup-close-btn"
              onClick={() => setPopupDish(null)}
            >
              ✕
            </button>
          </div>
        </div>
      </div>
    );
  };

 


const fetchAISuggestions = async (dish) => {
    if (suggestionPopup.loading) return;

    try {
      setSuggestionPopup((prev) => ({
        ...prev,
        loading: true
      }));

      await new Promise((r) =>
        setTimeout(r, 1200)
      );

      const currentCategory = dish.category;

      const candidates = dishes.filter(
        (d) =>
          d.id !== dish.id &&
          d.category !== currentCategory
      );

      const shuffled = [...candidates]
        .sort(() => 0.5 - Math.random());

      const suggestions =
        shuffled.slice(0, 4);

      setSuggestionPopup((prev) => ({
        ...prev,
        loading: false,
        suggestions
      }));

    } catch (err) {
      console.error(
        "Errore suggerimenti:",
        err
      );

      setSuggestionPopup({
        open: false,
        dish: null,
        suggestions: [],
        loading: false,
        custom: "",
        asked: false
      });
    }
  };

  // ===========================
  // AGGIUNGI PIATTO
  // ===========================
 const addDishToCart = async (dish, quantity, custom) => {
  try {
    if (slotAsportoEnabled && !slotSelezionato) {
      showSnack("⏰ Seleziona prima un orario disponibile", "error");
      return;
    }

    if (slotAsportoEnabled && isSlotCompleto(slotSelezionato)) {
      showSnack("⛔ Questo orario è completo", "error");
      setSlotSelezionato("");
      return;
    }

    const { name: resolvedName } = resolveDishText(dish, lingua);

      // Cerca l'item esistente direttamente in ordineCondiviso
      const esistente = ordineCondiviso.find(
        (item) =>
          item.dishId === dish.id &&
          (item.custom || "") === custom
      );

      if (esistente) {
        // Aggiorna quantità eliminando e ri-aggiungendo
        const oldQty = esistente.quantity || 0;
        const ref = doc(ordinePath, esistente.id);
        await deleteDoc(ref);
        await addDoc(ordinePath, {
  dishId: dish.id,
  name: resolvedName,
  category: dish.category,
  price: dish.price,
  quantity: oldQty + quantity,
  custom,
  clienteId,
  timestamp: new Date()
});
      } else {
        // Aggiunge nuovo item
        await addDoc(ordinePath, {
  dishId: dish.id,
  name: resolvedName,
  category: dish.category,
  price: dish.price,
  quantity,
  custom,
  clienteId,
  timestamp: new Date()
});
      }

      setInputValues((prev) => ({
        ...prev,
        [dish.id]: { quantity: 1, custom: "" }
      }));

      showSnack(TT.itemAdded, "success");
    } catch (e) {
      console.error("Errore aggiunta al carrello:", e);
      showSnack(TT.addError || "Errore aggiunta piatto", "error");
    }
  };

  // ===========================
  // Sidebar, invio ordine
  // ===========================

  const eliminaItemTemp = async (item) => {
    try {
      const ref = doc(ordinePath, item.id);
      await deleteDoc(ref);
      showSnack(TT.removedFromOrder || "Piatto rimosso", "info");
    } catch (e) {
      console.error("Errore eliminaItemTemp:", e);
      showSnack("Errore durante la rimozione", "error");
    }
  };

 const inviaOrdine = async () => {
  if (invioOrdineLockRef.current || invioOrdineInCorso) {
    return;
  }

  // Su iOS senza PWA, FCM non funziona: saltiamo il blocco notifiche
    const iosSafariNoPwa = isIOS && !isStandalone;
    if (!notificationsEnabled && !skipNotificationsOnce && !iosSafariNoPwa) {
      setShowNotifyExplain(true);
      return;
    }

    if (ENABLE_OTP && !phoneVerified) {
      // Chiudo la sidebar così l'OTP sheet è visibile e usabile
      setShowRiepilogo(false);
      setOtpOpen(true);
      setOtpStep("phone");
      return;
    }
    await inviaOrdineFinale();
  };


const inviaOrdineFinale = async () => {
  // Blocca immediatamente eventuali chiamate duplicate
  if (invioOrdineLockRef.current) {
    return;
  }

  invioOrdineLockRef.current = true;
  setInvioOrdineInCorso(true);

  try {
    // 🔥 BLOCCO LOCALE
    const localeRef = doc(db, "locali", normalizedLocaleTag);
    const localeSnap = await getDoc(localeRef);

    if (
      localeSnap.exists() &&
      localeSnap.data().stato === "bloccato"
    ) {
      showSnack("🚫 Locale non disponibile", "error");
      return;
    }

    // Usa ordineCondiviso come sorgente degli items
    if (ordineCondiviso.length === 0) {
      showSnack(TT.noDishSelected, "error");
      return;
    }

    if (slotAsportoEnabled && !slotSelezionato) {
      showSnack(
        "⏰ Seleziona un orario prima di inviare l'ordine",
        "error"
      );
      return;
    }

    let effectiveFcmToken = fcmToken;
if (
  !effectiveFcmToken &&
  "Notification" in window &&
  Notification.permission === "granted"
) {
  const messagingSupported = await isSupported();

  if (messagingSupported) {
    const messaging = getMessaging();
    effectiveFcmToken = await getToken(messaging);

    if (effectiveFcmToken) {
      setFcmToken(effectiveFcmToken);
      setNotificationsEnabled(true);

      localStorage.setItem(
        "qrmenu_notifications_completed",
        "true"
      );
    }
  }
}

      const items = ordineCondiviso.map((item) => ({
  dishId: item.dishId,
  name: item.name,
  category: item.category || "",
  price: item.price,
  quantity: item.quantity,
  custom: item.custom
}));

      let quantitaSlotPrenotata = 0;

if (slotAsportoEnabled) {
  const categorieConteggiate =
  asportoSlotsConfig.categorieConteggiate || [];

quantitaSlotPrenotata = items.reduce((acc, item) => {
  if (!categorieConteggiate.includes(item.category)) {
    return acc;
  }

  return acc + Number(item.quantity || 0);
}, 0);

  const slotDocRef = doc(
    db,
    "asporto_slot_occupazione",
    `${normalizedLocaleTag}_${oggiSlotKey}`
  );

  try {
    await runTransaction(db, async (transaction) => {
      const snap = await transaction.get(slotDocRef);
      const data = snap.exists() ? snap.data() : {};
      const slots = data.slots || {};

      const slotId = getSlotId(slotSelezionato);
      const giaOccupati = Number(slots[slotId] || 0);

      if (giaOccupati + quantitaSlotPrenotata > maxPezziPerSlot) {
  const errore = new Error("SLOT_COMPLETO");
  errore.disponibili =
    maxPezziPerSlot - giaOccupati;

  throw errore;
}

      transaction.set(
        slotDocRef,
        {
          locale: normalizedLocaleTag,
          data: oggiSlotKey,
          slots: {
            ...slots,
            [slotId]: giaOccupati + quantitaSlotPrenotata
          },
          updatedAt: serverTimestamp()
        },
        { merge: true }
      );
    });
  } catch (err) {
 if (err.message === "SLOT_COMPLETO") {
  setShowRiepilogo(false);

  showSnack(
    `⛔ Per questo orario sono rimasti disponibili solo ${Math.max(
      err.disponibili || 0,
      0
    )} pezzi`,
    "error",
    5000
  );

  setSlotFullPopup(true);
  setSlotSelezionato("");

  return;
}

    console.error("Errore prenotazione slot:", err);
    showSnack("Errore controllo disponibilità orario", "error");
    return;
  }
}

      let totale = items.reduce((acc, it) => {
        return acc + ((it.price || 0) * (it.quantity || 0));
      }, 0);

      totale = Math.round(totale * 100) / 100;

      // Determina il numero ordine da usare
      const contatoreRef = doc(
        db,
        "contatori_ordini_asporto",
        normalizedLocaleTag
      );

      const contatoreSnap = await getDoc(contatoreRef);

      const ultimoNumeroContatore = contatoreSnap.exists()
        ? Number(contatoreSnap.data().ultimoNumero || 0)
        : 0;

      let nuovoNumero = numeroOrdine;
      let deveCrearenumero = false;

      // Se il contatore è stato azzerato dalla dashboard,
      // invalida il vecchio numero salvato nella PWA.
      if (
        nuovoNumero &&
        Number(nuovoNumero) > ultimoNumeroContatore
      ) {
        localStorage.removeItem(
          `ordineAsportoOpt_${normalizedLocaleTag}`
        );

        setNumeroOrdine(null);
        nuovoNumero = null;
        deveCrearenumero = true;
      }

      // Se il numero salvato è ancora valido,
      // verifica se l'ordine è ancora attivo.
      if (nuovoNumero && !deveCrearenumero) {
        const ordineAsportoRef = doc(
          db,
          "ordini_asporto",
          `${normalizedLocaleTag}_${nuovoNumero}`
        );

        const ordineSnap = await getDoc(ordineAsportoRef);

        if (
          ordineSnap.exists() &&
          ordineSnap.data().stato === "inviato"
        ) {
          // Ordine ancora attivo: riutilizza lo stesso numero
          deveCrearenumero = false;
        } else {
          // Ordine concluso: genera un nuovo numero
          deveCrearenumero = true;
        }
      } else if (!nuovoNumero) {
        deveCrearenumero = true;
      }

      // Genera il nuovo progressivo
      if (deveCrearenumero) {
        nuovoNumero = ultimoNumeroContatore + 1;

        await setDoc(
          contatoreRef,
          { ultimoNumero: nuovoNumero },
          { merge: true }
        );
      }

      // Se stiamo riusando il numero, cerca l'ordine esistente in "ordini"
      let ordineEsistenteRef = null;
      let ordineEsistenteData = null;
      if (!deveCrearenumero) {
        const q = query(
          collection(db, "ordini"),
          where("numeroOrdineAsporto", "==", nuovoNumero),
          where("locale", "==", normalizedLocaleTag),
          where("stato", "==", "inviato")
        );
        const snapshot = await getDocs(q);
        if (!snapshot.empty) {
          ordineEsistenteRef = doc(db, "ordini", snapshot.docs[0].id);
          ordineEsistenteData = snapshot.docs[0].data();
        }
      }

      // Crea o aggiorna ordine nella collection "ordini" (per cucina/cassa)
      if (ordineEsistenteRef && ordineEsistenteData) {
        // Aggiorna ordine esistente: combina items nuovi con quelli vecchi
        const vecchiItems = ordineEsistenteData.items || [];
        const nuoviItems = items.map((it) => ({
          name: it.name,
          category: it.category || "",
          quantity: it.quantity,
          custom: it.custom || "",
          price: it.price
        }));

        // Combina: per lo stesso piatto, somma le quantità
        const itemsCombinati = [...vecchiItems];
        nuoviItems.forEach((nuovoItem) => {
          const esistente = itemsCombinati.find(
            (v) => v.name === nuovoItem.name && v.custom === nuovoItem.custom
          );
          if (esistente) {
            // Piatto già presente, aumenta quantità
            esistente.quantity = (esistente.quantity || 0) + nuovoItem.quantity;
          } else {
            // Nuovo piatto, aggiungilo
            itemsCombinati.push(nuovoItem);
          }
        });

        // Ricalcola il totale con gli items combinati
        const totaleCombinato = itemsCombinati.reduce((acc, it) => {
          return acc + ((it.price || 0) * (it.quantity || 0));
        }, 0);
        const totaleCombinato_rounded = Math.round(totaleCombinato * 100) / 100;

await setDoc(ordineEsistenteRef, {
  items: itemsCombinati,
  note,
  totale: totaleCombinato_rounded,
  vistoInCucina: false,
  timestamp: serverTimestamp(),
  ...(effectiveFcmToken && {
    fcmToken: effectiveFcmToken
  })
}, { merge: true });
      } else {
        // Crea nuovo ordine
        await addDoc(collection(db, "ordini"), {
          locale: normalizedLocaleTag,
          table: `ASPORTO-${nuovoNumero}`,
          chiaveTavolo: `${normalizedLocaleTag}_ASPORTO_${nuovoNumero}`,
          numeroOrdineAsporto: nuovoNumero,
          tipoOrdine: "ASPORTO",
          vistoInCucina: false,
          slotAsporto: slotAsportoEnabled ? slotSelezionato : null,
slotData: slotAsportoEnabled ? oggiSlotKey : null,
slotQuantita: slotAsportoEnabled ? quantitaSlotPrenotata : null,
          telefonoCliente: phoneNumber || null,
          items: items.map((it) => ({
  name: it.name,
  category: it.category || "",
  quantity: it.quantity,
  custom: it.custom || "",
  price: it.price
})),
          note,
          stato: "inviato",
          totale,
          timestamp: serverTimestamp(),
          ...(effectiveFcmToken && {
            fcmToken: effectiveFcmToken
          })
        });
      }

      // Salva/aggiorna in ordini_asporto per tracking cliente
      const ordineId = `${normalizedLocaleTag}_${nuovoNumero}`;
      
      // Leggi ordine precedente se esiste (per aggiornamenti)
      const ordineAsportoRef = doc(db, "ordini_asporto", ordineId);
      const ordineAsportoSnap = await getDoc(ordineAsportoRef);
      let itemsFinali = items.map((it) => ({
  name: it.name,
  category: it.category || "",
  quantity: it.quantity,
  custom: it.custom || "",
  price: it.price
}));
      let totaleFinale = totale;

      if (ordineAsportoSnap.exists()) {
        // Ordine esiste già, combina gli items
        const vecchiItems = ordineAsportoSnap.data().items || [];
        const itemsCombinati = [...vecchiItems];
        
        itemsFinali.forEach((nuovoItem) => {
          const esistente = itemsCombinati.find(
            (v) => v.name === nuovoItem.name && v.custom === nuovoItem.custom
          );
          if (esistente) {
            esistente.quantity = (esistente.quantity || 0) + nuovoItem.quantity;
          } else {
            itemsCombinati.push(nuovoItem);
          }
        });

        itemsFinali = itemsCombinati;
        totaleFinale = itemsFinali.reduce((acc, it) => {
          return acc + ((it.price || 0) * (it.quantity || 0));
        }, 0);
        totaleFinale = Math.round(totaleFinale * 100) / 100;
      }

      await setDoc(ordineAsportoRef, {
        locale: normalizedLocaleTag,
        numeroOrdine: nuovoNumero,
        slotAsporto: slotAsportoEnabled ? slotSelezionato : null,
slotData: slotAsportoEnabled ? oggiSlotKey : null,
slotQuantita: slotAsportoEnabled ? quantitaSlotPrenotata : null,
        telefonoCliente: phoneNumber || null,
        items: itemsFinali,
        note,
        stato: "inviato",
        totale: totaleFinale,
        timestamp: serverTimestamp(),
        ...(effectiveFcmToken && {
          fcmToken: effectiveFcmToken
        })
      });

      // ✅ Aggiorna anche ordini con il fcmToken (source of truth)
      if (effectiveFcmToken && ordineEsistenteRef) {
        // Se abbiamo già un riferimento all'ordine esistente, aggiornalo
        await updateDoc(ordineEsistenteRef, {
          fcmToken: effectiveFcmToken
        });
      } else if (effectiveFcmToken) {
        // Altrimenti cerca l'ordine appena creato e aggiornalo
        const qOrdini = query(
          collection(db, "ordini"),
          where("numeroOrdineAsporto", "==", nuovoNumero),
          where("locale", "==", normalizedLocaleTag),
          where("stato", "==", "inviato")
        );
        const ordiniSnapshot = await getDocs(qOrdini);
        if (!ordiniSnapshot.empty) {
          await updateDoc(doc(db, "ordini", ordiniSnapshot.docs[0].id), {
            fcmToken: effectiveFcmToken
          });
        }
      }

      // Salva numero ordine in localStorage
      localStorage.setItem(`ordineAsportoOpt_${normalizedLocaleTag}`, nuovoNumero.toString());
      setNumeroOrdine(nuovoNumero);
    
      // Stampa se abilitata
      if (infoLocale.stampaAutomaticaOrdini) {
        const printContent = `
<div style="font-family: monospace; width: 300px; padding: 10px;">
  <h2 style="text-align:center; color: #ff6b00;">🥡 ORDINE ASPORTO #${nuovoNumero}</h2>
  <strong style="display:block;">${
    infoLocale.titolo || "ASPORTO"
  }</strong><br/>
  <strong>Data: ${new Date().toLocaleString("it-IT")}</strong>
  <hr/>
  ${items
    .map(
      (it) =>
        `<div><strong>${it.quantity}x ${it.name}</strong>${
          it.custom ? "<br/><em>" + it.custom + "</em>" : ""
        }</div>`
    )
    .join("")}
  <hr/>
  Note: ${note || "Nessuna"}<br/>
  <h3 style="text-align:center;">Totale: €${totale.toFixed(2)}</h3>
</div>
`;
    
        const pw = window.open("", "", "width=400,height=600");
        pw.document.write(printContent);
        pw.document.close();
        pw.print();
      }
    
      // Elimina tutti gli items dal carrello
      for (const item of ordineCondiviso) {
        const ref = doc(ordinePath, item.id);
        await deleteDoc(ref);
      }
      
setNote("");
setShowRiepilogo(false);
setSkipNotificationsOnce(false);
showSnack(TT.orderSent, "success");
      
      // Pulisce la sessione auth SOLO se OTP è attivo
      if (ENABLE_OTP && phoneVerified) {
        await auth.signOut();
        setPhoneVerified(false);
      }
  } catch (error) {
    console.error("❌ Errore invio ordine:", error);
    showSnack("Errore invio ordine", "error");
  } finally {
    invioOrdineLockRef.current = false;
    setInvioOrdineInCorso(false);
  }
};

  const SlotAsportoSelector = () => {
  if (!slotAsportoEnabled) return null;

  return ReactDOM.createPortal(
    <div className="slot-asporto-overlay">
      <div className="slot-asporto-card">
        <h3>⏰ Scegli orario di ritiro</h3>
        <p>
          Seleziona uno slot disponibile prima di aggiungere i prodotti.
        </p>

        <div className="slot-asporto-grid">
          {slotsDisponibili.map((slot) => {
            const occupati = getOccupatiSlot(slot);
            const completo = isSlotCompleto(slot);
            const selezionato = slotSelezionato === slot;
            const disponibili = Math.max(maxPezziPerSlot - occupati, 0);

            return (
              <button
                key={slot}
                type="button"
                disabled={completo}
                className={[
  "slot-asporto-btn",
  selezionato ? "selected" : "",
  completo ? "full" : "",
  !completo && disponibili <= Math.ceil(maxPezziPerSlot * 0.3) ? "almost-full" : "",
  !completo && disponibili > Math.ceil(maxPezziPerSlot * 0.3) ? "available" : ""
].join(" ")}
                onClick={() => {
                  if (completo) return;
                  setSlotSelezionato(slot);
                }}
              >
                <strong>{slot}</strong>
               <span>
  {completo
    ? "Completo"
    : disponibili <= Math.ceil(maxPezziPerSlot * 0.3)
      ? "Si sta riempiendo"
      : "Disponibile"}
</span>
              </button>
            );
          })}
        </div>

        {slotSelezionato && (
          <button
            type="button"
            className="slot-asporto-confirm"
          >
            Confermato: {slotSelezionato}
          </button>
        )}
      </div>
    </div>,
    document.body
  );
};

  // ===========================
  // SIDEBAR RIEPILOGO - PULSANTI ORIZZONTALI
  // ===========================

  const SidebarRiepilogo = () => {
    if (!showRiepilogo) return null;

    return (
      <div className="sidebar">
        <div className="sidebar-header">
          <h3>🧾 {TT.orderSummary}</h3>
          <button
            className="sidebar-close-btn"
            onClick={() => setShowRiepilogo(false)}
          >
            <span className="close-icon">×</span>
          </button>
        </div>

        <div className="sidebar-content">
          {ordineCondiviso.length === 0 ? (
            <p className="empty-msg">{TT.noDishAdded}</p>
          ) : (
            ordineCondiviso.map((item) => (
              <div key={item.id} className="cart-item-row">
                <div className="cart-item-left">
                  <strong>{item.name}</strong>
                  {item.custom && (
                    <p className="cart-item-note">📝 {item.custom}</p>
                  )}
                </div>

                <div className="qty-controls">
                  <button
                    className="qty-btn"
                    onClick={async () => {
                      if (item.quantity > 1) {
                        try {
                          await updateDoc(doc(ordinePath, item.id), { quantity: item.quantity - 1, timestamp: serverTimestamp() });
                        } catch (e) {
                          console.error("Errore update quantità:", e);
                        }
                      } else {
                        eliminaItemTemp(item);
                      }
                    }}
                  >
                    −
                  </button>

                  <span className="qty-number">{item.quantity}</span>

                  <button
                    className="qty-btn"
                    onClick={async () => {
                      try {
                        await updateDoc(doc(ordinePath, item.id), { quantity: item.quantity + 1, timestamp: serverTimestamp() });
                      } catch (e) {
                        console.error("Errore update quantità:", e);
                      }
                    }}
                  >
                    +
                  </button>
                </div>
              </div>
            ))
          )}

{slotAsportoEnabled && (
  <div
    style={{
      marginTop: "12px",
      marginBottom: "12px",
      padding: "12px",
      borderRadius: "12px",
      background: "rgba(255,255,255,0.06)",
      border: "1px solid rgba(255,255,255,0.08)",
      textAlign: "center",
      fontWeight: "600"
    }}
  >
    {slotSelezionato
      ? `⏰ Ritiro previsto: ${slotSelezionato}`
      : "⏰ Nessun orario selezionato"}
  </div>
)}

          <textarea
            className="note-input"
            rows={2}
            placeholder={TT.notesPlaceholder}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            style={{ marginTop: "10px" }}
          />

          {/* ORDINI INVIATI */}
          {ordiniInviati.length > 0 && (
            <div style={{ marginTop: "20px", borderTop: "1px solid rgba(255,255,255,0.08)", paddingTop: "10px" }}>
              <h4 style={{ fontSize: "14px", fontWeight: "600", marginBottom: "8px" }}>
                📋 Ordini inviati {numeroOrdine ? `#${numeroOrdine}` : ''}
              </h4>
              {ordiniInviati.map((ordine) => (
                <div key={ordine.id} className="sent-order-block">
                  <strong>Stato: {ordine.stato}</strong>
                  <div className="sent-order-items">
                    {ordine.items?.map((item, idx) => (
                      <p key={idx}>• {item.quantity}x {item.name}</p>
                    ))}
                  </div>
                  <div style={{ marginTop: "4px", fontWeight: "600" }}>
                    Totale: €{ordine.totale?.toFixed(2) || '0.00'}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* PULSANTI ORIZZONTALI IN BASSO */}
        <div className="sidebar-actions">
          {notificationsEnabled && (
            <div style={{
              background: "linear-gradient(135deg, #4CAF50, #45a049)",
              color: "#fff",
              padding: "8px 12px",
              borderRadius: "8px",
              fontSize: "13px",
              marginBottom: "8px",
              textAlign: "center"
            }}>
              ✅ Notifiche attive
            </div>
          )}
<button
  className="btn-send"
  onClick={inviaOrdine}
  disabled={invioOrdineInCorso}
  style={{
    opacity: invioOrdineInCorso ? 0.65 : 1,
    cursor: invioOrdineInCorso ? "not-allowed" : "pointer"
  }}
>
  {invioOrdineInCorso
    ? "⏳ Invio in corso..."
    : `🚀 ${TT.send}`}
</button>
          <button className="btn-close-sidebar" onClick={() => setShowRiepilogo(false)}>
            ✖ Chiudi
          </button>
        </div>
      </div>
    );
  };

  // ===========================
  // AI post ordine, Sponsor, Promozioni
  // ===========================

  // ...existing code...

  const SponsorPopup = () => {
    if (!showSponsor || !currentSponsor) return null;

    return ReactDOM.createPortal(
      <>
        <div
          className="popup-overlay"
          onClick={() => setShowSponsor(false)}
        />

        <div
          className="popup-card"
          style={{
            width:
              currentSponsor.dimensione === "fullscreen"
                ? "min(92vw, 500px)"
                : currentSponsor.dimensione === "grande"
                ? "min(92vw, 420px)"
                : currentSponsor.dimensione === "medio"
                ? "min(92vw, 380px)"
                : "min(92vw, 340px)"
          }}
        >
          {/* Header stile Instagram */}
          <div className="ig-post-header">
            <div className="ig-avatar">
              <span>{(currentSponsor.titolo || "S").charAt(0).toUpperCase()}</span>
            </div>
            <div className="ig-meta">
              <span className="ig-username">{currentSponsor.titolo || "Sponsor"}</span>
              <span className="ig-sponsored">Sponsorizzato</span>
            </div>
            <button
              className="popup-close-btn"
              onClick={() => setShowSponsor(false)}
            >
              ✕
            </button>
          </div>

          <div
            className="popup-img-wrapper"
            onClick={() => {
              if (currentSponsor.link) {
                window.open(currentSponsor.link, "_blank", "noopener,noreferrer");
                setShowSponsor(false);
              }
            }}
          >
            <img src={currentSponsor.imageUrl} alt={currentSponsor.titolo} />
          </div>

          {/* Footer stile Instagram */}
          <div className="ig-post-footer">
            <div className="ig-actions">
              <span className="ig-action-icon">♥</span>
              <span className="ig-action-icon">💬</span>
              <span className="ig-action-icon">✈</span>
            </div>
            {currentSponsor.titolo && (
              <p className="ig-caption">
                <strong>{currentSponsor.titolo}</strong>
              </p>
            )}
          </div>
        </div>
      </>,
      document.body
    );
  };

  const PromoPopup = () => {
    if (!showPromozione || !currentPromozione) return null;

    return ReactDOM.createPortal(
      <>
        <div
          className="popup-overlay"
          onClick={() => setShowPromozione(false)}
        />

        <div
          className="popup-card"
          style={{
            width:
              currentPromozione.dimensione === "fullscreen"
                ? "min(92vw, 500px)"
                : currentPromozione.dimensione === "grande"
                ? "min(92vw, 420px)"
                : currentPromozione.dimensione === "medio"
                ? "min(92vw, 380px)"
                : "min(92vw, 340px)"
          }}
        >
          {/* Header stile Instagram */}
          <div className="ig-post-header">
            <div className="ig-avatar ig-avatar--promo">
              <span>{(currentPromozione.titolo || "P").charAt(0).toUpperCase()}</span>
            </div>
            <div className="ig-meta">
              <span className="ig-username">{currentPromozione.titolo || "Promozione"}</span>
              <span className="ig-sponsored">🔥 Offerta speciale</span>
            </div>
            <button
              className="popup-close-btn"
              onClick={() => setShowPromozione(false)}
            >
              ✕
            </button>
          </div>

          <div
            className="popup-img-wrapper"
            onClick={() => {
              if (currentPromozione.link) {
                window.open(currentPromozione.link, "_blank", "noopener,noreferrer");
                setShowPromozione(false);
              }
            }}
          >
            <img src={currentPromozione.imageUrl} alt={currentPromozione.titolo} />
          </div>

          {/* Footer stile Instagram */}
          <div className="ig-post-footer">
            <div className="ig-actions">
              <span className="ig-action-icon">♥</span>
              <span className="ig-action-icon">💬</span>
              <span className="ig-action-icon">✈</span>
            </div>
            {currentPromozione.titolo && (
              <p className="ig-caption">
                <strong>{currentPromozione.titolo}</strong>
              </p>
            )}
          </div>
        </div>
      </>,
      document.body
    );
  };

  // ===========================
  // RETURN COMPLETO
  // ===========================

  return (
    <div className={`menu-root ${isDarkMode ? "dark" : "light"} menu-asporto-opt`}>
      <div id="recaptcha-container"></div>
      {invioOrdineInCorso && ReactDOM.createPortal(
  <div
    style={{
      position: "fixed",
      inset: 0,
      zIndex: 999999,
      background: "rgba(0,0,0,0.72)",
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "24px",
      cursor: "wait"
    }}
  >
    <div
      style={{
        width: "min(86vw, 330px)",
        padding: "28px 22px 24px",
        borderRadius: "22px",
        background:
          "linear-gradient(145deg, rgba(34,34,38,0.98), rgba(20,20,24,0.98))",
        border: "1px solid rgba(255,255,255,0.10)",
        boxShadow:
          "0 24px 70px rgba(0,0,0,0.55), 0 0 30px rgba(10,132,255,0.12)",
        textAlign: "center",
        color: "#fff"
      }}
    >
      <div
        style={{
          width: "54px",
          height: "54px",
          margin: "0 auto 20px",
          borderRadius: "50%",
          border: "4px solid rgba(255,255,255,0.14)",
          borderTopColor: "#0a84ff",
          animation: "spin 0.85s linear infinite"
        }}
      />

      <div
        style={{
          fontSize: "1.05rem",
          fontWeight: "800",
          marginBottom: "9px",
          letterSpacing: "-0.02em"
        }}
      >
        Invio ordine in corso
      </div>

      <div
        style={{
          fontSize: "0.88rem",
          lineHeight: 1.5,
          color: "#b7b7bd"
        }}
      >
        Stiamo inviando il tuo ordine alla cucina.
        <br />
        Attendi qualche secondo.
      </div>

      <div
        style={{
          marginTop: "18px",
          padding: "9px 12px",
          borderRadius: "12px",
          background: "rgba(10,132,255,0.10)",
          border: "1px solid rgba(10,132,255,0.18)",
          color: "#7db9ff",
          fontSize: "0.76rem",
          fontWeight: "600"
        }}
      >
        Non chiudere questa schermata
      </div>
    </div>

    <style>
      {`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}
    </style>
  </div>,
  document.body
)}
      <OtpBottomSheet
        otpOpen={otpOpen}
        otpStep={otpStep}
        phoneDigits={phoneDigits}
        phoneDigitsConfirm={phoneDigitsConfirm}
        otpCode={otpCode}
        phoneNumber={phoneNumber}
        phoneInputRef={phoneInputRef}
        otpInputRef={otpInputRef}
        setOtpOpen={setOtpOpen}
        setPhoneDigits={setPhoneDigits}
        setPhoneDigitsConfirm={setPhoneDigitsConfirm}
        setOtpCode={setOtpCode}
        sendOtp={sendOtp}
        verifyOtp={verifyOtp}
        forceFocus={forceFocus}
        loadingPhone={loadingPhone}
        loadingOtp={loadingOtp}
        setUserEditingPhone={setUserEditingPhone}
      />
      {showIosInstructions && (
        <>
          <div
            className="ios-install-overlay"
            onClick={() => setShowIosInstructions(false)}
          />
          <div className="ios-install-sheet">
            <div className="ios-install-title">
              Installa QrMenu
            </div>

            <div className="ios-install-text">
              Per ricevere notifiche:
              <br />
              1. Premi <strong>Condividi</strong>
              <br />
              2. Seleziona <strong>Aggiungi a Home</strong>
            </div>

            <button
              className="ios-install-btn primary"
              onClick={() => setShowIosInstructions(false)}
            >
              Ho capito
            </button>

            <button
              className="ios-install-btn secondary"
              onClick={() => setShowIosInstructions(false)}
            >
              Continua senza installare
            </button>
          </div>
        </>
      )}
      {showAndroidInstall && (
        <>
          <div
            className="ios-install-overlay"
            onClick={() => {
              setShowAndroidInstall(false);
            }}
          />
          <div className="ios-install-sheet">
            <div className="ios-install-title">
              Installa QrMenu
            </div>

            <div className="ios-install-text">
              Installa l'app per ricevere notifiche
              e aggiornamenti in tempo reale.
            </div>

            <button
              className="ios-install-btn primary"
              onClick={async () => {
                if (deferredPrompt) {
                  deferredPrompt.prompt();
                  const choice = await deferredPrompt.userChoice;

                  if (choice.outcome === "accepted") {
                    setDeferredPrompt(null);
                  }
                }

                setShowAndroidInstall(false);
              }}
            >
              Installa ora
            </button>

            <button
              className="ios-install-btn secondary"
              onClick={() => {
                setShowAndroidInstall(false);
              }}
            >
              Continua senza installare
            </button>
          </div>
        </>
      )}
      {/* HEADER TOPBAR CON LOGO E LINGUA */}
      <div className="categoria-nav">
        {/* LOGO FISSO A SINISTRA */}
        {infoLocale.logoUrl && (
          <div className="nav-logo">
            <img
              src={infoLocale.logoUrl}
              alt={infoLocale.nome || "Logo"}
            />
          </div>
        )}

        {/* SELETTORE LINGUA DROPDOWN (Mobile-First) - PIÙ PICCOLO */}
        {infoLocale.mostraSelezioneLingue && availableLangs.length > 1 && (
          <div className="lang-dropdown-wrapper">
            <button
              type="button"
              className="lang-flag-button"
              onClick={() => setLangDropdownOpen(!langDropdownOpen)}
              aria-label={`Lingua: ${lingua.toUpperCase()}`}
              aria-expanded={langDropdownOpen}
            >
              <span>{langFlags[lingua] || "🌐"}</span>
            </button>

            {langDropdownOpen && (
              <>
                <div
                  className="lang-dropdown-overlay"
                  onClick={() => setLangDropdownOpen(false)}
                />

                <div
                  className="lang-dropdown"
                  role="menu"
                  aria-label="Seleziona lingua"
                >
                  {availableLangs
                    .filter((lang) => lang !== lingua)
                    .map((lang) => (
                      <button
                        key={lang}
                        type="button"
                        role="menuitem"
                        className="lang-dropdown-item"
                        aria-label={`Cambia lingua in ${lang.toUpperCase()}`}
                        onClick={() => {
                          setLingua(lang);
                          setLangDropdownOpen(false);
                        }}
                      >
                        <span className="lang-dropdown-flag">
                          {langFlags[lang] || "🌐"}
                        </span>
                        <span className="lang-dropdown-label">
                          {lang.toUpperCase()}
                        </span>
                      </button>
                    ))}
                </div>
              </>
            )}
          </div>
        )}

        {/* PULSANTE AI NELLA NAVBAR */}
        <div style={{ 
          flex: 1, 
          minWidth: 0, 
          display: "flex", 
          justifyContent: "flex-end",
          gap: "8px"
        }}>
          {/* AI */}
          <button
            type="button"
            style={{ 
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "#fff",
              fontWeight: "600",
              border: "none",
              borderRadius: "8px",
              padding: "8px 14px",
              fontSize: "14px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "6px"
            }}
            onClick={() => setAiOpen(true)}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M6 8h12a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-2l-2-2h-4l-2 2H6a3 3 0 0 1-3-3v-2a3 3 0 0 1 3-3z"/>
              <path d="M8 12h3"/>
              <path d="M9.5 10.5v3"/>
              <circle cx="16.5" cy="11.5" r="0.5" fill="currentColor"/>
              <circle cx="18.5" cy="13.5" r="0.5" fill="currentColor"/>
            </svg>
            <span>AI</span>
          </button>
        </div>
      </div>

      <div className="top-spacer" />

      {/* BANNER PROMOZIONALE FISSO */}
{bannersPromozionali.length > 0 && (
  <div
    className="mv-banner-wrapper"
    onClick={() => {
      const current = bannersPromozionali[currentBannerPromoIndex];
      if (current?.link) {
        window.open(current.link, "_blank", "noopener,noreferrer");
      }
    }}
  >
    <img
      src={bannersPromozionali[currentBannerPromoIndex]?.imageUrl}
      alt={bannersPromozionali[currentBannerPromoIndex]?.titolo || "Banner"}
      className="mv-banner-image"
    />
    {bannersPromozionali[currentBannerPromoIndex]?.titolo && (
      <div className="mv-banner-overlay">
        <span className="mv-banner-title">
          {bannersPromozionali[currentBannerPromoIndex]?.titolo}
        </span>
      </div>
    )}
  </div>
)}

      {/* LAYOUT SHELL: SIDEBAR + MAIN */}
      <div className="mv-shell">
        {/* BARRA CATEGORIE ORIZZONTALE */}
        <aside className={`mv-sidebar ${infoLocale.menuConFoto === false ? "no-foto" : ""}`}>
          <div className="mv-sidebar-inner" ref={sidebarRef}>
            <button
              type="button"
              className={`mv-catbtn ${!activeCategory ? "active" : ""}`}
              onClick={() => {
                setSelectedCategory(null);
                setActiveCategory(null);
                const el = document.querySelector(".mv-main");
                if (el) el.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              <span className="mv-caticon">🍽️</span>
              <span className="mv-catlabel">Tutto</span>
            </button>

            {categorie.map((cat) => (
              <button
                key={cat.id}
                type="button"
                data-cat={getCatId(cat.nome)}
                className={`mv-catbtn ${infoLocale.menuConFoto === false ? "no-foto" : ""} ${activeCategory === getCatId(cat.nome) ? "active" : ""}`}
                onClick={() => {
                  setSelectedCategory(null);
                  setActiveCategory(getCatId(cat.nome));

                  const el = document.getElementById(`cat-${getCatId(cat.nome)}`);
                  const container = document.querySelector(".mv-main");

                  if (el && container) {
                    const rect = el.getBoundingClientRect();
                    const containerRect = container.getBoundingClientRect();
                    const top = rect.top - containerRect.top + container.scrollTop - 20;
                    container.scrollTo({ top, behavior: "smooth" });
                  }
                }}
              >
                {infoLocale.menuConFoto !== false && (
                  <span className="mv-caticon">
                    {(() => {
                      const avatar = getCategoryAvatar(cat.nome);
                      if (avatar) {
                        return (
                          <img
                            src={avatar}
                            alt={resolveCategoryName(cat, lingua)}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "16px"
                            }}
                          />
                        );
                      }
                      return getCategoryIcon(resolveCategoryName(cat, lingua) || cat.nome);
                    })()}
                  </span>
                )}
                <span className="mv-catlabel">{resolveCategoryName(cat, lingua)}</span>
              </button>
            ))}
          </div>
        </aside>

        {/* MAIN CONTENT AREA */}
        <main className="mv-main">
          {loading ? (
            <div className="menu-loading">
              <div className="spinner"></div>
              <p>Stiamo caricando il menu…</p>
            </div>
          ) : (
            <div className="mv-content">
              {(() => {
                const categorieDaMostrare = categorie;
                return categorieDaMostrare.map((cat) => (
                  <section key={cat.id} className="mv-section">
                    <h3 id={`cat-${getCatId(cat.nome)}`} className="mv-section-title">
                      {resolveCategoryName(cat, lingua)}
                    </h3>

                    <div className="mv-grid">
                      {dishes
                        .filter((d) => d.category === cat.nome)
                        .sort((a, b) => (a.ordine || 0) - (b.ordine || 0))
                        .map((dish) => (
                          <div key={dish.id} className="mv-grid-item">
                            {renderDishCard(dish)}
                          </div>
                        ))}
                    </div>
                  </section>
                ));
              })()}
            </div>
          )}
        </main>
      </div>
      {/* GIOCHI FAB RIMOSSO - BOTTONE SPOSTATO NELLA NAVBAR */}
      {infoLocale.consentOrdine && (
        <>
          {!showRiepilogo && (
            <button
              type="button"
              className="chat-ai-fab"
              onClick={() => setChatOpen(true)}
              aria-label="Apri chat AI"
            >
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" aria-hidden="true">
                <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"/>
              </svg>
            </button>
          )}

          {/* CHAT AI CLIENTE */}
          {chatOpen && (
            <ChatAICliente
              localeTag={normalizedLocaleTag}
              menu={dishes}
              open={chatOpen}
              onClose={() => setChatOpen(false)}
            />
          )}
        </>
      )}

      {/* BOTTOM BAR */}
      <div className="bottom-bar">
        {infoLocale.consentOrdine &&
  !notificationsEnabled &&
  (!isIOS || isStandalone) && (
    <button
      className="bottom-btn notify"
      onClick={handleEnableNotificationsSmart}
      style={{
        background: "linear-gradient(135deg, #FF9800, #FF5722)",
        color: "#fff",
        fontWeight: "600",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px"
      }}
    >
      🔔 Notifiche
    </button>
)}

        {infoLocale.consentOrdine && (
          <button
            className="bottom-btn cart"
            onClick={() => setShowRiepilogo(true)}
          >
            🛒 Riepilogo ({totalePiatti})
            {totalePiatti > 0 && (
              <span className="bottom-cart-badge">
                {totalePiatti}
              </span>
            )}
          </button>
        )}
      </div>

      {/* SPACER */}
      <div className="bottom-spacer" />

{slotAsportoEnabled && !slotSelezionato && <SlotAsportoSelector />}

      {/* POPUP IMMAGINE */}
      <PopupDish />

<SuggestionPopup
  suggestionPopup={suggestionPopup}
  selectedSuggestions={selectedSuggestions}
  setSuggestionPopup={setSuggestionPopup}
  setSelectedSuggestions={setSelectedSuggestions}
  fetchAISuggestions={fetchAISuggestions}
  addDishToCart={addDishToCart}
  TT={TT}
/>


      {/* SIDEBAR RIEPILOGO */}
      <SidebarRiepilogo />

      {showConfirmSendPopup && ReactDOM.createPortal(
        <div className="portal-overlay">
          <div className="popup-card" style={{ padding: "24px", textAlign: "center" }}>

            <h3 style={{ marginBottom: "10px" }}>
              ✅ Numero verificato
            </h3>

            <p style={{ marginBottom: "20px", fontSize: "15px" }}>
              Premi il pulsante per inviare l'ordine alla cucina.
            </p>

            <button
              style={{
                background: "linear-gradient(135deg, #4CAF50, #2E7D32)",
                color: "#fff",
                padding: "14px",
                borderRadius: "12px",
                width: "100%",
                fontWeight: "600",
                border: "none",
                cursor: "pointer",
                fontSize: "16px"
              }}
              onClick={async () => {
                setShowConfirmSendPopup(false);
                await inviaOrdineFinale();
              }}
            >
              🚀 Invia ordine
            </button>

            <button
              style={{
                marginTop: "10px",
                background: "transparent",
                border: "none",
                color: "#666",
                cursor: "pointer"
              }}
              onClick={() => setShowConfirmSendPopup(false)}
            >
              Annulla
            </button>

          </div>
        </div>,
        document.body
      )}

      {/* NUOVO AICliente – ai consigli dal menu reale */}
      <AICliente
        localeTag={normalizedLocaleTag}
        menu={dishes}
        lingua={lingua}
        openFromNavbar={aiOpen}
        onClose={() => setAiOpen(false)}
      />
      {/* POPUP SPONSOR */}
      <SponsorPopup />

      {/* POPUP PROMOZIONE */}
      <PromoPopup />

      {/* POPUP ESPLICATIVO NOTIFICHE — Portal: renderizzato su document.body,
           sopra TUTTO (sidebar, OTP, promo) indipendentemente dallo stacking context */}
      {showNotifyExplain && ReactDOM.createPortal(
        <div className="notify-explain-overlay">
          <div className="notify-explain-card">
            <h3>🔔 Attiva le notifiche</h3>
            <p>
              Le notifiche ti avvisano quando l'ordine è in preparazione o pronto.
            </p>

            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <button
                className="btn-primary"
                onClick={async () => {
                  try {
                    setNotifLoading(true);
                    await enableNotificationsManually();
                    // Notifiche attivate con successo.
                    // NON chiamare inviaOrdine() perché setNotificationsEnabled(true)
                    // è asincrono e il check !notificationsEnabled tornerebbe true.
                    // Saltiamo il check usando skipNotificationsOnce=true
                    // e andiamo direttamente al flusso OTP.
                    setShowNotifyExplain(false);
                    setShowRiepilogo(false);
                    setSkipNotificationsOnce(true);
                    if (ENABLE_OTP && !phoneVerified) {
                      setOtpOpen(true);
                      setOtpStep("phone");
                    } else {
                      await inviaOrdineFinale();
                    }
                  } catch(e) {
                    console.error(e);
                  } finally {
                    setNotifLoading(false);
                  }
                }}
                style={{
                  background: "linear-gradient(135deg, #FF9800, #FF5722)",
                  color: "#fff",
                  border: "none",
                  padding: "14px",
                  borderRadius: "12px",
                  fontWeight: "600",
                  fontSize: "16px",
                  cursor: "pointer",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  boxShadow: notifLoading
                    ? "0 0 0 3px rgba(255,152,0,0.3)"
                    : "0 4px 12px rgba(0,0,0,0.2)",
                  transition: "all 0.2s ease"
                }}
              >
                {notifLoading ? (
                  <>
                    <span className="spinner-mini"></span>
                    Attivazione in corso...
                  </>
                ) : (
                  <>🔔 Attiva notifiche</>
                )}
              </button>

              <button
                className="btn-secondary"
                style={{
                  background: "transparent",
                  color: "#FF9800",
                  border: "none",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  fontWeight: "600",
                  cursor: "pointer",
                  textDecoration: "underline"
                }}
                onClick={() => {
                  setSkipNotificationsOnce(true);
                  setShowNotifyExplain(false);
                  setShowRiepilogo(false);
                  inviaOrdine();
                }}
              >
                Continua senza notifiche
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

{slotFullPopup && ReactDOM.createPortal(
  <div className="portal-overlay">
    <div className="slot-full-popup-card">
      <h3 style={{ marginBottom: "10px" }}>
        ⏰ Orario non più disponibile
      </h3>

<p style={{ marginBottom: "20px", fontSize: "15px", lineHeight: 1.5 }}>
  Per questo orario il numero massimo di prodotti prenotabili è stato raggiunto.

  <br /><br />

  Seleziona un altro orario di ritiro e riprova.
</p>

      <button
        style={{
          background: "linear-gradient(135deg, #ff8c00, #ff5e00)",
          color: "#fff",
          padding: "14px",
          borderRadius: "12px",
          width: "100%",
          fontWeight: "700",
          border: "none",
          cursor: "pointer",
          fontSize: "16px"
        }}
        onClick={() => {
          setSlotFullPopup(false);
        }}
      >
        Scegli un altro orario
      </button>
    </div>
  </div>,
  document.body
)}

      {/* SNACKBAR */}
      {snackbar.visible && (
        <div className="snackbar">{snackbar.message}</div>
      )}
    </div>
  );
}

export default MenuAsportoOpt;
